<template>
  <div class="person-form main-content-cj h-100 mh-100">
    <b-container class="d-flex flex-column h-100 mh-100">
      <div class="main-header">
        <b-row class="align-items-center">
          <b-col cols="12" md="6" class="d-flex align-content-center">
            <span class="title">Informações d{{ letter }} {{ termSingular }}</span>
          </b-col>
          <b-col cols="12" md="6" v-if="personForm.type == 'PROFESSIONAL' && $route.params.id != newTerm">
            <b-row class="d-flex align-items-center justify-content-end" >
              <b-col cols="auto">
                <router-link tag="a" class="btn btn-primary btn-sm" :to="'/profissionais/' + $route.params.id + '/cartao-digital'"><i class="far fa-address-card"></i> Cartão digital</router-link>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <hr class="mb-0">
      </div>
      <div class="box-container">
        <b-row class="mb-1" v-if="personForm.birthday && moment(personForm.birthday, 'DD/MM/YYYY').isValid() && Math.abs(moment(personForm.birthday.substring(0, 5), 'DD/MM').diff(moment(), 'days')) <= 7">
          <b-col>
            <div class="alert text-center" :class="Math.abs(moment(personForm.birthday.substring(0, 5), 'DD/MM').diff(moment().startOf('day'), 'days')) <= 1 ? 'alert-success' : 'alert-info'" role="alert">
              <p class="mb-0" v-if="moment(personForm.birthday.substring(0, 5), 'DD/MM').diff(moment().startOf('day'), 'days') == 0">🥳 O aniversário de {{ personForm.name }} é hoje!</p>
              <p class="mb-0" v-else-if="moment(personForm.birthday.substring(0, 5), 'DD/MM').diff(moment().startOf('day'), 'days') > 0">🥳 O aniversário de {{ personForm.name }} é {{moment(personForm.birthday.substring(0, 5), 'DD/MM').diff(moment().startOf('day'), 'days') == 1 ? 'amanhã' : ('dia ' + personForm.birthday.substring(0, 5))}}!</p>
              <p class="mb-0" v-else>🥳 O aniversário de {{ personForm.name }} foi {{moment(personForm.birthday.substring(0, 5), 'DD/MM').diff(moment().startOf('day'), 'days') == -1 ? 'ontem' : ('dia ' + personForm.birthday.substring(0, 5))}}!</p>
            </div>
          </b-col>
        </b-row>
        <b-form-row class="mb-3" v-show="preview">
          <b-col cols="12" md="8">
            <b-form-row>
              <b-col cols="12" lg="7">
                <div class="box-cj">
                  <div class="header">
                    <p class="title">Informações pessoais</p>
                  </div>
                  <div class="content">
                    <b-row class="mb-2">
                      <b-col>
                        <b-row>
                          <div class="photo-container" v-if="personForm.type == 'PATIENT' || personForm.type == 'PROFESSIONAL'">
                            <div id="personPhotoPreview" class="person-photo rounded" title="Foto"></div>
                          </div>
                          <b-col>
                            <label class="cj-label">Nome</label><br/>
                            <span class="preview name">{{ personForm.name }}<span v-if="personForm.internal_code != null && personForm.internal_code != ''"> ({{ personForm.internal_code }})</span></span>
                            <div><small>{{ (moment(personForm.birthday, 'DD/MM/YYYY').isValid())?moment.duration(moment().diff(moment(personForm.birthday, 'DD/MM/YYYY'))).format('Y [anos], M [meses], dd [dias]'):'' }}</small></div>
                          </b-col>
                        </b-row>
                        <hr>
                      </b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col cols="12" xl="6">
                        <label class="cj-label">Celular</label><br/>
                        <span class="preview">{{ personForm.cellphone }}</span>
                      </b-col>
                      <b-col cols="12" xl="6">
                        <label class="cj-label">Telefone</label><br/>
                        <span class="preview">{{ personForm.telephone }}</span>
                      </b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col>
                        <label class="cj-label">E-mail</label><br/>
                        <span class="preview">{{ personForm.email }}</span>
                      </b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col cols="12" xl="6">
                        <label class="cj-label">Convênio</label><br/>
                        <span class="preview">{{ personForm.health_plan != null ? personForm.health_plan.name : '' }}</span>
                      </b-col>
                      <b-col cols="12" xl="6">
                        <label class="cj-label">Número da Carteira</label><br/>
                        <span class="preview">{{ personForm.card_number }}</span>
                      </b-col>
                    </b-row>
                    <b-row class="mb-2" v-if="(personForm.responsible_name != null && personForm.responsible_name != '') || (personForm.responsible_document != null && personForm.responsible_document != '') || (personForm.responsible_kinship != null && personForm.responsible_kinship != '') || (personForm.responsible_email != null && personForm.responsible_email != '') || (personForm.responsible_phone != null && personForm.responsible_phone != '') || (personForm.responsible_notes != null && personForm.responsible_notes != '')">
                      <b-col>
                        <hr>
                        <b-row>
                          <b-col cols="12" xl="6">
                            <label class="cj-label">Nome do(a) responsável</label><br/>
                            <span class="preview">{{ personForm.responsible_name }}</span>
                          </b-col>
                          <b-col cols="12" xl="6">
                            <label class="cj-label">CPF do(a) responsável</label><br/>
                            <span class="preview">{{ personForm.responsible_document }}</span>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col cols="12" xl="6">
                            <label class="cj-label">Parentesco do(a) responsável</label><br/>
                            <span class="preview">{{ personForm.responsible_kinship }}</span>
                          </b-col>
                          <b-col cols="12" xl="6">
                            <label class="cj-label">E-mail do(a) responsável</label><br/>
                            <span class="preview">{{ personForm.responsible_email }}</span>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col cols="12" xl="6">
                            <label class="cj-label">Telefone do(a) responsável</label><br/>
                            <span class="preview">{{ personForm.responsible_phone }}</span>
                          </b-col>
                          <b-col cols="12" xl="6">
                            <label class="cj-label">Notas do(a) responsável</label><br/>
                            <span class="preview">{{ personForm.responsible_notes }}</span>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                    <b-row class="mb-2" v-if="(personForm.responsible2_name != null && personForm.responsible2_name != '') || (personForm.responsible2_document != null && personForm.responsible2_document != '') || (personForm.responsible2_kinship != null && personForm.responsible2_kinship != '') || (personForm.responsible2_email != null && personForm.responsible2_email != '') || (personForm.responsible2_phone != null && personForm.responsible2_phone != '') || (personForm.responsible2_notes != null && personForm.responsible2_notes != '')">
                      <b-col>
                        <hr>
                        <b-row>
                          <b-col cols="12" xl="6">
                            <label class="cj-label">Nome do(a) responsável 2</label><br/>
                            <span class="preview">{{ personForm.responsible2_name }}</span>
                          </b-col>
                          <b-col cols="12" xl="6">
                            <label class="cj-label">CPF do(a) responsável 2</label><br/>
                            <span class="preview">{{ personForm.responsible2_document }}</span>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col cols="12" xl="6">
                            <label class="cj-label">Parentesco do(a) responsável 2</label><br/>
                            <span class="preview">{{ personForm.responsible2_kinship }}</span>
                          </b-col>
                          <b-col cols="12" xl="6">
                            <label class="cj-label">E-mail do(a) responsável 2</label><br/>
                            <span class="preview">{{ personForm.responsible2_email }}</span>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col cols="12" xl="6">
                            <label class="cj-label">Telefone do(a) responsável 2</label><br/>
                            <span class="preview">{{ personForm.responsible2_phone }}</span>
                          </b-col>
                          <b-col cols="12" xl="6">
                            <label class="cj-label">Notas do(a) responsável 2</label><br/>
                            <span class="preview">{{ personForm.responsible2_notes }}</span>
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                  </div>
                  <div class="footer text-center text-uppercase show-full">
                    <span @click="preview = false">Ver informações completas</span>
                  </div>
                </div>
              </b-col>
              <b-col cols="12" lg="5">
                <div class="box-cj mb-4">
                  <div class="header">
                    <p class="title">Resumo de Agendamentos</p>
                  </div>
                  <div class="content">
                    <b-row>
                      <b-col cols="6" lg="12" xl="6">
                        <label class="cj-label">Agendamentos</label><br/>
                        <span class="preview">{{ this.appointments.length }}</span>
                      </b-col>
                      <b-col cols="6" lg="12" xl="6">
                        <label class="cj-label">Atendimentos</label><br/>
                        <span class="preview">{{ this.appointments.filter(appointment => (appointment.status == 'SHOWEDUP' || appointment.status == 'ATTENDED')).length }}</span>
                      </b-col>
                      <b-col cols="6" lg="12" xl="6">
                        <label class="cj-label">Faltas</label><br/>
                        <span class="preview">{{ this.appointments.filter(appointment => (appointment.status == 'MISSED')).length }}</span>
                      </b-col>
                      <b-col cols="6" lg="12" xl="6">
                        <label class="cj-label">Cancelamentos</label><br/>
                        <span class="preview">{{ this.appointments.filter(appointment => (appointment.status == 'CANCELED')).length }}</span>
                      </b-col>
                    </b-row>
                  </div>
                </div>
                <div v-if="helpers.planHasPermission('financial')" class="box-cj">
                  <div class="header d-flex justify-content-between">
                    <p class="title">Contas a Receber</p>
                    <div>
                      <router-link tag="a" class="print-ico" target="_blank" :to="{path:'/financeiro/contas-a-receber', query:{min_date:transactionSummary.min_registration_date, max_date:transactionSummary.max_registration_date, period_filter:'registration_date', patient_id:personForm.id, patient_name:personForm.name}}"><i class="far fa-eye"></i></router-link>
  <!--                  <a :href="aolUrl + agendaForm.id" v-if="agendaForm.online_scheduling" target="_blank" class="mr-3"><i class="far fa-link"></i></a>-->
                    </div>
                  </div>
                  <div class="content">
                    <b-row>
                      <b-col cols="6" lg="12" xl="6">
                        <label class="cj-label">Pago</label><br/>
                        <span class="preview">R$ {{ formatPrice(transactionSummary.paid) }}</span>
                      </b-col>
                      <b-col cols="6" lg="12" xl="6">
                        <label class="cj-label">Vencido</label><br/>
                        <span class="preview">R$ {{ formatPrice(transactionSummary.overdue) }}</span>
                      </b-col>
                      <b-col cols="6" lg="12" xl="6">
                        <label class="cj-label">Futuro</label><br/>
                        <span class="preview">R$ {{ formatPrice(transactionSummary.future) }}</span>
                      </b-col>
                      <b-col cols="6" lg="12" xl="6">
                        <label class="cj-label">Total</label><br/>
                        <span class="preview">R$ {{ formatPrice(transactionSummary.total) }}</span>
                      </b-col>
                    </b-row>
                  </div>
                </div>
              </b-col>
            </b-form-row>
            <div class="box-cj" v-if="helpers.isOwner() || (user && (user.person.type == 'SECRETARY' || user.person.type == 'PROFESSIONAL')) || helpers.checkPermission('attendance-guides', 'can_see', true)">
              <div class="header">
                <p class="title">Guias de Atendimento</p>
              </div>
              <div class="content">
                <table class="table table-responsive w-100 d-block d-md-table table-centered">
                  <thead>
                    <tr>
                      <th>Número da guia</th>
                      <th>Data do<br>atendimento</th>
                      <th>Convênio</th>
                      <th>Profissional</th>
                      <th>Status</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="attendanceGuide in attendanceGuides" :key="'attendanceGuides-'+attendanceGuide.id">
                      <td>{{ attendanceGuide.internal_id }}</td>
                      <td>{{ moment(attendanceGuide.appointment.start_datetime).format('DD/MM/YY HH:mm') }}</td>
                      <td>{{ attendanceGuide.appointment.health_plan.name }}</td>
                      <td>{{ attendanceGuide.appointment.professional.name }}</td>
                      <td>{{ attendanceGuide.pending?'Aberta':'Fechada' }}</td>
                      <td>
                        <b-button size="sm" variant="primary" @click="showAttendanceGuideModal(attendanceGuide)" v-if="canEdit" class="mr-1"><i :class="'far ' + (attendanceGuide.pending ? 'fa-pencil-alt' : 'fa-eye')"></i></b-button>
                        <b-button size="sm" variant="danger" @click="deleteAttendanceGuide(attendanceGuide)" v-if="canEdit && attendanceGuide.pending && attendanceGuide.items.filter(item => (item.attendance_guide_invoice_id != null)).length == 0 && (helpers.isOwner() || (user && (user.person.type == 'SECRETARY' || user.person.type == 'PROFESSIONAL')) || helpers.checkPermission('attendance-guides', 'can_remove', true))"><i class="far fa-trash-alt"></i></b-button>
                      </td>
                    </tr>
                    <tr v-if="attendanceGuides.length == 0">
                      <td colspan="5" class="text-center">
                        Este paciente não possui nenhuma guia de atendimento.
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="footer text-center text-uppercase show-full" v-if="attendanceGuideAppointment != null && canEdit && (helpers.isOwner() || (user && (user.person.type == 'SECRETARY' || user.person.type == 'PROFESSIONAL')) || helpers.checkPermission('attendance-guides', 'can_add', true))">
                <span @click="showAttendanceGuideModal(null)">Gerar guia de atendimento</span>
              </div>
            </div>
            <div class="box-cj" v-if="user != null && (typeof user.person.client.profile == 'undefined' || user.person.client.profile == '' || user.person.client.profile == 'DENTIST')">
              <div class="header">
                <p class="title">Orçamentos</p>
              </div>
              <div class="content">
                <table class="table table-responsive w-100 d-block d-md-table table-centered">
                  <thead>
                    <tr>
                      <th>Data</th>
                      <th>Título</th>
                      <th>Total</th>
                      <th>Status</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="quote in quotes" :key="'quotes-'+quote.id">
                      <td>{{ moment(quote.created_at).format('DD/MM/YY HH:mm') }}</td>
                      <td>{{ quote.title }}</td>
                      <td>R$ {{ formatPrice(quote.items.reduce((total, item) => total + item.value, 0)) }}</td>
                      <td>{{ quote.status }}</td>
                      <td>
                        <b-button size="sm" variant="primary" @click="editQuote(quote)" v-if="canEdit" class="mr-1"><i class="far fa-pencil-alt"></i></b-button>
                        <b-button size="sm" variant="danger" @click="deleteQuote(quote)" v-if="canEdit"><i class="far fa-trash-alt"></i></b-button>
                      </td>
                    </tr>
                    <tr v-if="quotes.length == 0">
                      <td colspan="5" class="text-center">
                        Este paciente não possui nenhum orçamento.
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
<!--              <div class="footer text-center text-uppercase show-full" v-if="canEdit">-->
<!--                <span @click="showQuoteModal">Realizar novo orçamento</span>-->
<!--              </div>-->
            </div>
            <div v-if="timer != null">
              <validation-observer ref="attendanceForms" v-slot="{ invalid }">
                <div class="box-cj" v-for="attendanceForm in attendanceForms" :key="'attendanceForms-'+attendanceForm.id">
                  <div class="header">
                    <div class="d-flex justify-content-between align-items-center">
                      <p class="title">Prontuário</p>
                      <div>
                        <label class="cj-label pointer" @click="removeAttendanceForm(attendanceForm.id, attendanceForm.form != null ? attendanceForm.form.value : null)">Deletar prontuário <i class="far fa-trash ml-2"></i></label>
                      </div>
                    </div>
                  </div>
                  <div class="content">
                    <b-row class="mb-2">
                      <b-col lg="8">
                        <label class="cj-label">Modelo de prontuário</label>
                        <multiselect v-model="attendanceForm.form" :options="getAvailableForms(attendanceForm.form)" track-by="name" label="name" :showLabels="false" :allow-empty="false" :searchable="true" placeholder="Escolha um para começar"></multiselect>
                      </b-col>
                    </b-row>
                    <b-row v-if="attendanceForm.form != null">
                      <b-col v-for="field in attendanceForm.form.fields" :key="'formFields-'+field.id" :lg="field.cols" :order="field.order" class="mb-2">
                        <FormField :field="field"></FormField>
                      </b-col>
                    </b-row>
                  </div>
                </div>
              </validation-observer>
              <b-button block class="btn-add-new mb-4" v-if="getAvailableForms(null).length > 0 && showAddNewButton()" @click="addNewFormToAttendance"><i class="far fa-plus-circle mr-2"></i> Adicionar prontuário</b-button>

              <div class="box-cj" v-for="prescription in attendancePrescriptions" :key="'prescriptions-'+prescription.id">
                <div class="header">
                  <div class="d-flex justify-content-between align-items-center">
                    <p class="title">Receituário</p>
                    <div>
                      <label class="cj-label pointer" @click="removePrescription(prescription)">Deletar receituário <i class="far fa-trash ml-2"></i></label>
                    </div>
                  </div>
                </div>
                <div class="content">
                  <b-row>
                    <b-col cols="12" class="mb-1" v-if="prescription.value.AtestadoPDFUrl != null">
                      <a :href="prescription.value.AtestadoPDFUrl" target="_blank"><i class="far fa-notes-medical"></i> Atestado</a>
                    </b-col>
                    <b-col cols="12" class="mb-1" v-if="prescription.value.PDFUrl != null">
                      <a :href="prescription.value.PDFUrl" target="_blank"><i class="far fa-pills"></i> Receita(s)</a>
                    </b-col>
                    <b-col cols="12" class="mb-1" v-if="prescription.value.ExamePDFUrl  != null">
                      <a :href="prescription.value.ExamePDFUrl " target="_blank"><i class="far fa-stethoscope"></i> Pedido(s) de exame</a>
                    </b-col>
                  </b-row>
                </div>
              </div>
              <b-button block class="btn-add-new-green" v-if="showAddNewPrescriptionButton()" @click="addNewPrescriptionToAttendance"><i class="far fa-plus-circle mr-2"></i> Adicionar receituário</b-button>
            </div>
          </b-col>
          <b-col cols="12" md="4" class="mh-100">
            <div>
              <div class="box-cj box-collapse">
                <div class="header d-flex justify-content-between align-items-center py-2" v-if="user != null && user.person.type == 'PROFESSIONAL'">
                  <div class="title">Marcador de atendimento</div>
                  <div class="time">{{ (timer == null)?'00:00:00':timer }}</div>
                </div>
                <div class="content today-appointments">
                  <ul class="appointments-list mb-1" v-if="todayAppointments.length > 0">
                    <li class="current-day">
                      <span class="timeline"></span>
                      <p class="date">{{ moment().format('DD/MM/YYYY (dddd)') }}</p>
                      <template v-for="appointment in todayAppointments">
                        <p :key="'appointments-'+appointment.id" class="info ml-3">
                          <small class="d-flex flex-column" :class="{ 'ufoGreen': (appointment.status == 'SHOWEDUP' || appointment.status == 'ATTENDED'), 'dullRed': (appointment.status == 'MISSED' || appointment.status == 'CANCELED') }">
                            <div class="row">
                              <span class="col-6 text-nowrap overflow-hidden" :title="moment(appointment.start_datetime).format('HH:mm')"><i class="far" :class="{ 'fa-calendar': (appointment.status != 'SHOWEDUP' && appointment.status != 'ATTENDED' && appointment.status != 'MISSED' && appointment.status != 'CANCELED'), 'fa-calendar-check ufoGreen': (appointment.status == 'SHOWEDUP' || appointment.status == 'ATTENDED'), 'fa-calendar-times dullRed': (appointment.status == 'MISSED' || appointment.status == 'CANCELED') }"></i> {{ moment(appointment.start_datetime).format('HH:mm') }}</span>
                              <span class="col-6 text-nowrap overflow-hidden" :title="appointment.professional.name"><i class="far fa-user-tie"></i> {{ appointment.professional.name }}</span>
                              <span class="col-6 text-nowrap overflow-hidden" :title="appointment.health_plan.name"><i class="far fa-file-invoice-dollar"></i> {{ appointment.health_plan.name }}</span>
                              <span class="col-6 text-nowrap overflow-hidden" :title="helpers.getStatusName(appointment.status)"><i class="far fa-info-circle"></i> {{ helpers.getStatusName(appointment.status) }}
                                <i @click="showAppointmentAudit(appointment.id)" class="fas fa-history float-right audit-btn pt-1" title="Log de alterações"></i>
                              </span>

                              <div v-if="user != null && user.person.type == 'PROFESSIONAL' && appointment.professional.id === user.person.id && (appointment.status == 'SHOWEDUP' || (helpers.planHasPermission('telehealth') && appointment.telehealth && ['SCHEDULED', 'CONFIRMED'].indexOf(appointment.status) >= 0))" class="col-12 text-center mt-2">
                                <b-button variant="primary" @click="startAttendanceAppointment(appointment.id)" class="mb-1" :disabled="!canPerformAction" v-if="timer == null"><i class="far fa-sm fa-play-circle mr-2 "></i> Iniciar atendimento{{helpers.planHasPermission('telehealth') && appointment.telehealth ? ' online' : ''}}</b-button>
                              </div>
                              <div v-else-if="user != null && user.person.type == 'PROFESSIONAL' && appointment.professional.id !== user.person.id && helpers.planHasPermission('telehealth') && appointment.telehealth && ['SCHEDULED', 'CONFIRMED'].indexOf(appointment.status) >= 0 && user.person.client.enable_multi_professional_telehealth_attendance" class="col-12 text-center mt-2">
                                <router-link tag="a" target="_blank" class="btn btn-primary" :to="'/pacientes/' + $route.params.id + '/acompanhar-teleconsulta/' + appointment.id"><i class="fas fa-sm fa-external-link-alt mr-2 "></i> Acompanhar atendimento online</router-link>
                              </div>
                            </div>
                          </small>
                        </p>
                      </template>
                    </li>
                  </ul>

                  <div v-if="timer == null && user != null && user.person.type == 'PROFESSIONAL'" class="text-center text-uppercase show-full py-2">
                    <span @click="startAttendance()">Registrar um atendimento</span>
                  </div>
                  <div v-else-if="user != null && user.person.type == 'PROFESSIONAL'" class="col-12 text-center mt-2">
                    <div class="mb-2" v-if="attendanceInProgress != null && attendanceInProgress.telehealth_attendance != null && attendanceInProgress.telehealth_attendance.end_datetime == null && helpers.planHasPermission('telehealth')">
                      <router-link v-if="attendanceInProgress.professional_id === user.person.id" tag="a" target="_blank" class="btn btn-primary" :to="'/pacientes/' + $route.params.id + '/teleconsulta/' + attendanceInProgress.telehealth_attendance.id"><i class="fas fa-sm fa-external-link-alt mr-2 "></i> Abrir atendimento online</router-link>
                      <router-link v-else-if="user.person.client.enable_multi_professional_telehealth_attendance" tag="a" target="_blank" class="btn btn-primary" :to="'/pacientes/' + $route.params.id + '/acompanhar-teleconsulta/' + attendanceInProgress.appointment_id"><i class="fas fa-sm fa-external-link-alt mr-2 "></i> Acompanhar atendimento online</router-link>
                    </div>
                    <b-button v-if="attendanceInProgress != null && attendanceInProgress.professional_id === user.person.id" variant="warning" @click="endAttendance()" class="mb-1" :disabled="!canPerformAction"><i class="far fa-sm fa-stop-circle mr-2 "></i> Encerrar atendimento</b-button>
                  </div>
                </div>
              </div>
              <div class="box-cj">
                <div class="header appointment-history-header">
                  <div class="w-100 d-flex justify-content-between">
                    <div class="d-flex flex-column flex-xl-row">
                      <b-tabs>
                        <b-tab title="Histórico" title-link-class="show-appointments" :active="activeTab === 'past-appointments'" @click="showTab('past-appointments')"></b-tab>
                        <b-tab title="Agendamentos" title-link-class="show-appointments" :active="activeTab === 'future-appointments'" @click="showTab('future-appointments')"></b-tab>
                        <b-tab title="Lembretes" title-link-class="show-appointments" :active="activeTab === 'reminders'" @click="showTab('reminders')"></b-tab>
                      </b-tabs>
                    </div>
                    <div>
                      <date-range-picker
                        class="only-icon"
                        ref="picker"
                        :localeData="dateRangePickerPtBrLocale"
                        :timePicker="false"
                        :timePicker24Hour="false"
                        :showDropdowns="true"
                        :ranges="false"
                        :showWeekNumbers="false"
                        :opens="'left'"
                        v-model="appointmentsFilter.dateTime">
                        <div slot="input" slot-scope="picker" class="text-center" style="margin:0; padding:0; border:0">
                          <span class="print-ico"><i class="far fa-search"></i></span>
                        </div>
                      </date-range-picker>
                      <span class="print-ico" @click="print" v-if="user != null && (user.person.type == 'PROFESSIONAL' || user.person.type == 'COORDINATOR' || (user.person.type == 'SECRETARY' && typeof user.person.can_see_forms != 'undefined' && user.person.can_see_forms)) && attendances.length > 0"><i class="far fa-print"></i></span>
                    </div>
                  </div>
                  <div class="w-100 d-flex justify-content-between" v-if="appointmentsFilter.dateTime.startDate != null">
                    <div>
                      <small class="cj-label">{{ moment(appointmentsFilter.dateTime.startDate).format('DD/MM/YYYY') }} - {{ moment(appointmentsFilter.dateTime.endDate).format('DD/MM/YYYY') }}</small>
                    </div>
                    <div>
                      <small class="print-ico" @click="cleanAppointmentsFilter">Limpar filtro</small>
                    </div>
                  </div>
                </div>
                <div class="content">
                  <perfect-scrollbar style="height: 490px">
                    <template v-if="activeTab === 'past-appointments' || activeTab === 'future-appointments'">
                      <ul class="appointments-list" v-if="getPersonTimeline().length > 0">
                        <li v-for="(date, index) in getPersonTimeline()" :class="moment(date).isSame(moment(), 'day') ? 'current-day' : ''" :key="'timeline-'+index">
                          <span class="timeline"></span>
                          <p class="date">{{ moment(date).format('DD/MM/YYYY (dddd)') }}</p>

                          <template v-if="getInfoByDate(date).appointments.length > 0">
                            <template v-for="appointment in getInfoByDate(date).appointments">
                              <p :key="appointment.id" class="info ml-3">
                                <small class="d-flex flex-column" :class="{ 'ufoGreen': (appointment.status == 'SHOWEDUP' || appointment.status == 'ATTENDED'), 'dullRed': (appointment.status == 'MISSED' || appointment.status == 'CANCELED') }">
                                  <div class="row">
                                    <span class="col-6 text-nowrap overflow-hidden" :title="moment(appointment.start_datetime).format('HH:mm')"><i class="far" :class="{ 'fa-calendar': (appointment.status != 'SHOWEDUP' && appointment.status != 'ATTENDED' && appointment.status != 'MISSED' && appointment.status != 'CANCELED'), 'fa-calendar-check ufoGreen': (appointment.status == 'SHOWEDUP' || appointment.status == 'ATTENDED'), 'fa-calendar-times dullRed': (appointment.status == 'MISSED' || appointment.status == 'CANCELED') }"></i> {{ moment(appointment.start_datetime).format('HH:mm') }}</span>
                                    <span class="col-6 text-nowrap overflow-hidden" :title="appointment.professional.name"><i class="far fa-user-tie"></i> {{ appointment.professional.name }}</span>
                                    <span class="col-6 text-nowrap overflow-hidden" :title="appointment.health_plan.name"><i class="far fa-file-invoice-dollar"></i> {{ appointment.health_plan.name }}</span>
                                    <span class="col-6 text-nowrap overflow-hidden" :title="helpers.getStatusName(appointment.status)"><i class="far fa-info-circle"></i> {{ helpers.getStatusName(appointment.status) }}
                                        <i @click="showAppointmentAudit(appointment.id)" class="fas fa-history float-right audit-btn pt-1" title="Log de alterações"></i>
                                    </span>
                                  </div>
                                </small>
                              </p>
                            </template>
                          </template>

                          <template v-if="user != null && (user.person.type == 'PROFESSIONAL' || user.person.type == 'COORDINATOR' || (user.person.type == 'SECRETARY' && typeof user.person.can_see_forms != 'undefined' && user.person.can_see_forms)) && getInfoByDate(date).attendances.length > 0 && attendancesWithFormsOrPrescriptions(getInfoByDate(date).attendances)">
                            <template v-for="attendance in getInfoByDate(date).attendances">
                              <p :key="'attendances-'+attendance.id" v-if="attendance.forms.length > 0 || attendance.prescriptions.length > 0" class="info ml-3">
                                <small class="d-flex flex-column">
                                  <div class="row">
                                    <span class="col-6 text-nowrap overflow-hidden" :title="moment(attendance.start_datetime).format('HH:mm')"><i class="far fa-calendar"></i> {{ moment(attendance.start_datetime).format('HH:mm') }}</span>
                                    <span class="col-6 text-nowrap overflow-hidden" :title="attendance.professional.name"><i class="far fa-user-tie"></i> {{ attendance.professional.name }}</span>

                                    <template v-for="form in attendance.forms">
                                      <span class="col-12 attendance-item" :key="attendance.id+form.id" @click="showForm(form, attendance)"><i class="far fa-notes-medical"></i> {{ form.name }}
                                        <i v-if="form.notes.length > 0 && (((user.person.client.enable_coordinator_profile || user.person.client.enable_professional_notes) && user.person.type == 'PROFESSIONAL' && user.person.id == attendance.professional_id) || (user.person.client.enable_coordinator_profile && user.person.type == 'COORDINATOR'))" class="far fa-comment-alt-lines float-right mt-1"></i>
                                      </span>
                                    </template>
                                    <template v-for="prescription in attendance.prescriptions">
                                      <a :key="prescription.id+'Atestado'" class="col-12 attendance-item mb-1" v-if="prescription.value.AtestadoPDFUrl != null" :href="prescription.value.AtestadoPDFUrl" target="_blank"><i class="far fa-notes-medical"></i> Atestado</a>
                                      <a :key="prescription.id+'Receita'" class="col-12 attendance-item mb-1" v-if="prescription.value.PDFUrl != null" :href="prescription.value.PDFUrl" target="_blank"><i class="far fa-pills"></i> Receita(s)</a>
                                      <a :key="prescription.id+'Exame'" class="col-12 attendance-item mb-1" v-if="prescription.value.ExamePDFUrl != null" :href="prescription.value.ExamePDFUrl" target="_blank"><i class="far fa-stethoscope"></i> Pedido(s) de exame</a>
                                    </template>
                                  </div>
                                </small>
                              </p>
                            </template>
                          </template>
                        </li>
                      </ul>
                      <p class="text-center" v-else-if="getPersonTimeline().length > 0 && appointmentsFilter.dateTime.startDate == null">Este paciente não possui nenhum atendimento.</p>
                      <p class="text-center" v-else>Este paciente não possui nenhum atendimento entre as datas informadas.</p>
                    </template>
                    <template v-else-if="activeTab === 'reminders'">
                      <b-button variant="primary" block v-if="user != null && (user.person.type == 'PROFESSIONAL' || user.person.type == 'COORDINATOR' || user.person.type == 'SECRETARY')" @click="showReminderModal()" class="mb-3"><i class="far fa-sm fa-plus-circle mr-2 "></i>  Adicionar lembrete</b-button>
                      <ul class="appointments-list" v-if="reminders.length > 0">
                        <li v-for="(date, index) in getPersonRemindersTimeline()" :class="moment(date).isSame(moment(), 'day') ? 'current-day' : ''" :key="'remindersTimeline-'+index">
                          <span class="timeline"></span>
                          <p class="date">{{ moment(date).format('DD/MM/YYYY (dddd)') }}</p>

                          <template v-if="getRemindersByDate(date).length > 0">
                            <template v-for="reminder in getRemindersByDate(date)">
                              <p :key="'reminders-'+reminder.id" class="info ml-3">
                                <small class="d-flex flex-column">
                                  <div class="row">
                                    <span @click="editReminder(reminder)" class="col-12 reminder-item mb-1" ><i class="far fa-tag"></i> {{ reminderTypes.find(reminderType => reminderType.value == reminder.reminder_type_id).name }}</span>
                                    <span @click="editReminder(reminder)" v-if="reminder.description" class="col-12 reminder-item mb-1" >{{ reminder.description }}</span>
                                  </div>
                                </small>
                              </p>
                            </template>
                          </template>
                        </li>
                      </ul>
                      <p class="text-center" v-else>Este paciente não possui nenhum lembrete.</p>
                    </template>
                  </perfect-scrollbar>
                  <template v-if="activeTab === 'past-appointments' || activeTab === 'future-appointments'">
                    <b-button variant="primary" block v-if="getPersonTimeline().length > 0 && hasMoreTimeline" @click="loadMoreAppointments()" class="mt-3"><i class="far fa-sm fa-redo mr-2 "></i>  Carregar mais atendimentos</b-button>
                    <b-button variant="primary" block v-if="showPastAppointments && getPersonTimeline().length > 0 && user != null && (user.person.type == 'PROFESSIONAL' || user.person.type == 'COORDINATOR' || (user.person.type == 'SECRETARY' && typeof user.person.can_see_forms != 'undefined' && user.person.can_see_forms))" @click="showFullHistory()" class="mt-3"><i class="far fa-sm fa-list mr-2 "></i>  Exibir histórico completo</b-button>
                  </template>
                </div>
              </div>
            </div>
          </b-col>

          <b-modal id="form-modal" class="form-modal" :size="formSelectedShowNotes ? 'xl' : 'lg'" :modalClass="'form-modal'" @hidden="resetFormModal">
            <template slot="modal-header" v-if="formSelected != null">
              <div class="w-100 d-flex justify-content-between">
                <div>
                  {{ formSelected.name }}
                </div>
                <div>
                  <span class="print-ico" @click="print"><i class="far fa-print"></i></span>
                  <span v-if="((user.person.client.enable_coordinator_profile || user.person.client.enable_professional_notes) && user.person.type == 'PROFESSIONAL' && user.person.id == formSelectedProfessionalId) || (user.person.client.enable_coordinator_profile && user.person.type == 'COORDINATOR')" class="notes-ico ml-3" @click="formSelectedShowNotes = !formSelectedShowNotes"><i class="far fa-comment-alt-lines"></i></span>
                </div>
              </div>
            </template>
            <template slot="default" v-if="formSelected != null">
              <b-row v-if="formSelected.fields.length > 0">
                <b-col>
                  <b-row>
                    <b-col v-for="field in formSelected.fields" :key="'selectedFormFields-'+field.id" :md="field.cols" :order="field.order" class="mb-2">
                      <FormField :field="field" :readonly="true" :preview="true"></FormField>
                    </b-col>
                  </b-row>
                </b-col>
                <b-col v-if="formSelectedShowNotes" cols="12" :md="4" class="notes-container">
                  <template v-for="note in formSelected.notes">
                    <div class="cj-form-field">
                      <label class="cj-label">{{moment(note.created_at).format('DD/MM/YYYY HH:mm')}} - {{note.person_name}}:</label>
                      <div>
                        <nl2br tag="p" :text="note.value" class-name="note-value mb-1" />
                      </div>
                    </div>
                  </template>
                  <template v-if="(user.person.client.enable_professional_notes && user.person.type == 'PROFESSIONAL' && user.person.id == formSelectedProfessionalId) || (user.person.client.enable_coordinator_profile && user.person.type == 'COORDINATOR')">
                    <validation-observer ref="noteForm" v-slot="{ invalid }">
                      <div :class="'cj-form-field' + (formSelected.notes.length > 0 ? ' mt-3' : '')">
                        <label class="cj-label">Anotação</label>
                        <div>
                          <validation-provider name="anotação" :rules="{ required: true }" v-slot="{ errors }">
                            <b-form-textarea v-model="formSelectedNote" rows="3" :class="{ 'error': errors.length > 0 }"></b-form-textarea>
                            <span class="cj-error">{{ errors[0] }}</span>
                          </validation-provider>
                        </div>
                      </div>
                    </validation-observer>
                    <div class="text-right mt-2">
                      <b-button size="sm" variant="primary" @click="saveFormNote">Enviar</b-button>
                    </div>
                  </template>
                </b-col>
              </b-row>
            </template>
            <template slot="modal-footer">
              <b-button size="sm" @click="$bvModal.hide('form-modal')">Fechar</b-button>
            </template>
          </b-modal>

          <b-modal id="audit-modal" class="audit-modal" :modalClass="'audit-modal'" size="lg">
            <template slot="modal-header">
              <div class="w-100 d-flex justify-content-between">
                <div>
                  Log de alterações do agendamento
                </div>
<!--                <div>-->
<!--                  <span class="print-ico" @click="print"><i class="far fa-print"></i></span>-->
<!--                </div>-->
              </div>
            </template>
            <template slot="default">
              <table class="table table-responsive w-100 d-block d-md-table table-centered table-cj mt-0">
                <thead>
                <tr>
                  <th>Data</th>
                  <th>Usuário</th>
                  <th>Alteração</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(audit, index) in appointmentAudits" :key="'appointmentAudit-'+index">
                  <td>{{ moment(audit.created_at).format('DD/MM/YYYY HH:mm:ss') }}</td>
                  <td>{{ audit.name }}</td>
                  <td v-html="audit.description"></td>
                </tr>
                <tr v-if="appointmentAudits.length == 0">
                  <td colspan="3" class="text-center">
                    Nenhuma alteração encontrada.
                  </td>
                </tr>
                </tbody>
              </table>
            </template>
            <template slot="modal-footer">
              <b-button size="sm" @click="$bvModal.hide('audit-modal')">Fechar</b-button>
            </template>
          </b-modal>

          <b-modal id="history-modal" class="history-modal" :modalClass="'history-modal'" size="lg">
            <template slot="modal-header">
              <div class="w-100 d-flex justify-content-between">
                <div>
                  Histórico do paciente {{ personForm.name }}
                </div>
                <div>
                  <span class="print-ico" @click="print"><i class="far fa-print"></i></span>
                </div>
              </div>
            </template>
            <template slot="default">
              <template v-for="(attendance, index) in attendances">
                <template v-for="form in attendance.forms">
                  <div :key="'attendanceForms-'+form.id" class="mt-3 mb-3">
                    <div class="text-center mb-5">
                      <h3 class="text-center">{{ form.name }} de {{ personForm.name }}</h3>
                      <h4 class="text-center">Atendido em {{ moment(attendance.start_datetime).format('DD/MM/YYYY HH:mm:ss') }} por {{ attendance.professional.name  }}</h4>
                      <h5 class="text-center" v-if="index == 0">Impresso em <b>{{ moment().format('DD/MM/YYYY HH:mm')}}</b> por <b>{{ user.name }}</b></h5>
                    </div>
                    <div class="mt-3 fields">
                      <div v-for="field in getFieldsInOrder(form.fields)" :key="'attendanceFormFields-'+field.id" class="field" :class="'field-'+field.cols">
                        <FormField :field="field" :readonly="true" :printable="true"></FormField>
                      </div>
                    </div>
                    <hr>
                  </div>
                </template>
              </template>
            </template>
            <template slot="modal-footer">
              <b-button size="sm" @click="$bvModal.hide('history-modal')">Fechar</b-button>
            </template>
          </b-modal>

          <b-modal id="quote-modal" class="quote-modal" size="lg" :modalClass="'quote-modal'" @hidden="resetQuoteModal">
            <template slot="modal-header">
              <div class="w-100 d-flex justify-content-between">
                <div>
                  Orçamento para {{ personForm.name }}
                </div>
                <div v-if="quoteForm.id != null">
                  <span class="print-ico" @click="print"><i class="far fa-print"></i></span>
                </div>
              </div>
            </template>
            <template slot="default">
              <b-col>
                <validation-observer ref="quoteForm" v-slot="{ invalid }">
                  <b-row class="mb-3">
                    <b-col>
                      <label class="cj-label">Título</label>
                      <validation-provider name="título" :rules="{ required: true }" v-slot="{ errors }">
                        <b-form-input type="text" v-model="quoteForm.title" autocomplete="off"></b-form-input>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                    <b-col v-if="user != null && (user.person.type == 'SECRETARY' || user.person.type == 'COORDINATOR')">
                      <label class="cj-label">Profissional</label>
                      <multiselect v-model="quoteForm.professional" :options="professionals" track-by="name" label="name" :preselectFirst="false" :showLabels="false" :allowEmpty="true" :searchable="true" :disabled="!((personForm.id == null && canAdd) || (personForm.id != null && canEdit))" placeholder="Selecione">
                        <template slot="clear">
                          <div class="multiselect__clear" v-if="quoteForm.professional != null" @mousedown.prevent.stop="quoteForm.professional = null"></div>
                        </template>
                      </multiselect>
                    </b-col>
                    <b-col>
                      <label class="cj-label">Status</label>
                      <validation-provider name="status" :rules="{ required: true }" v-slot="{ errors }">
                        <multiselect v-model="quoteForm.status" :options="quoteStatus" :preselectFirst="true" :allowEmpty="false" :showLabels="false" placeholder="Status" :class="{ 'error': errors.length > 0 }"></multiselect>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                  </b-row>
                </validation-observer>

                <hr>
                <validation-observer ref="quoteItemForm" v-slot="{ invalid }" v-if="quoteForm.status == 'Pendente'">
                  <b-col class="p-3 mb-3 background-color-whisper">
                    <b-row class="mb-2">
                      <b-col cols="6">
                        <label class="cj-label">Dente(s)</label>
                        <validation-provider name="dente(s)" :rules="{ required: true }" v-slot="{ errors }">
                          <multiselect v-model="quoteForm.item.teeth" :options="teeth" :showLabels="false" :searchable="true" :multiple="true" placeholder="Dente(s)" :class="{ 'error': errors.length > 0 }"></multiselect>
                          <span class="cj-error">{{ errors[0] }}</span>
                        </validation-provider>
                      </b-col>
                      <b-col cols="6">
                        <label class="cj-label">Face(s)</label>
                        <validation-provider name="face(s)" :rules="{ required: true }" v-slot="{ errors }">
                          <multiselect v-model="quoteForm.item.faces" :options="faces" :showLabels="false" :searchable="true" :multiple="true" placeholder="Face(s)" :class="{ 'error': errors.length > 0 }"></multiselect>
                          <span class="cj-error">{{ errors[0] }}</span>
                        </validation-provider>
                      </b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col cols="8">
                        <label class="cj-label">Procedimento</label>
                        <validation-provider name="procedimento" :rules="{ required: true }" v-slot="{ errors }">
                          <multiselect ref="multiselectProcedure" :preserveSearch="true" v-model="quoteForm.item.procedure" :options="procedures" track-by="name" label="name" :loading="isLoadingProcedures" :internal-search="false" :limit="5" :max-height="200" @search-change="findProcedures" :showLabels="false" placeholder="Selecione um procedimento" :class="{ 'error': errors.length > 0 }">
                            <template slot="noOptions">
                              <div>
                                Digite para pesquisar procedimentos...
                              </div>
                            </template>
                            <template slot="noResult" v-if="!isLoadingProcedures">
                              <div>
                                Nenhum procedimento encontrado...
                              </div>
                            </template>
                          </multiselect>
                          <span class="cj-error">{{ errors[0] }}</span>
                        </validation-provider>
                      </b-col>
                      <b-col>
                        <label class="cj-label">Valor</label>
                        <validation-provider name="valor" :rules="{ required: true }" v-slot="{ errors }">
                          <money v-model="quoteForm.item.value" class="form-control" :class="{ 'error': errors.length > 0 }"></money>
                          <span class="cj-error">{{ errors[0] }}</span>
                        </validation-provider>
                      </b-col>
                      <b-col cols="auto">
                        <label class="cj-label w-100 "> &nbsp;</label>
                        <b-button variant="success" @click="addItemToQuote">Adicionar</b-button>
                      </b-col>
                    </b-row>
                  </b-col>
                </validation-observer>

                <table class="table table-responsive w-100 d-block d-md-table table-centered table-cj">
                  <thead>
                    <tr>
                      <th>Dente(s)</th>
                      <th>Face(s)</th>
                      <th>Procedimento</th>
                      <th>Valor</th>
                      <th class="text-center">{{ (quoteForm.status == 'Aceito')?'Realizado?':'' }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) of quoteForm.items" :key="'quoteItems-'+index">
                      <td>{{ item.teeth.join(', ') }}</td>
                      <td>{{ item.faces.join(', ') }}</td>
                      <td>{{ item.procedure.name }}</td>
                      <td>R$ {{ formatPrice(item.value) }}</td>
                      <td class="text-center">
                        <b-button v-if="quoteForm.status == 'Pendente'" size="sm" variant="danger" @click="removeItemFromQuote(index)"><i class="far fa-trash-alt"></i></b-button>
                        <div class="pretty p-switch p-fill" v-if="quoteForm.status == 'Aceito'">
                          <input type="checkbox" v-model="item.accomplished" />
                          <div class="state p-success">
                            <label></label>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr v-if="quoteForm.items.length == 0">
                      <td colspan="5" class="text-center">
                        Nenhum item adicionado ao orçamento.
                      </td>
                    </tr>
                  </tbody>
                  <tfoot v-if="quoteForm.items.length > 0">
                    <tr>
                      <td></td>
                      <td></td>
                      <td class="text-right">Total:</td>
                      <td>R$ {{ formatPrice(quoteForm.items.reduce((total, item) => total + item.value, 0)) }}</td>
                      <td></td>
                    </tr>
                  </tfoot>
                </table>
              </b-col>
            </template>
            <template slot="modal-footer">
              <b-button size="sm" @click="$bvModal.hide('quote-modal')">Fechar</b-button>
              <b-button size="sm" variant="success" @click="saveQuote">Salvar</b-button>
            </template>
          </b-modal>

          <b-modal id="attendance-guide-modal" class="attendance-guide-modal" size="xl" ignore-enforce-focus-selector=".swal2-input" :modalClass="'attendance-guide-modal'" @hidden="resetAttendanceGuideModal">
            <template slot="modal-header">
              <div class="w-100 d-flex justify-content-between">
                <div v-if="attendanceGuideForm.id != null">
                  Guia de Atendimento #{{ attendanceGuideForm.internal_id }}
                </div>
                <div v-else>
                    Nova Guia de Atendimento para {{ attendanceGuideForm.name }}
                </div>
                <div v-if="attendanceGuideForm.id != null">
                  <router-link tag="a" target="_blank" class="print-ico" :to="'/guia-de-atendimento/' + attendanceGuideForm.id + '/imprimir'"><i class="far fa-print"></i></router-link>
                </div>
              </div>
            </template>
            <template slot="default">
              <b-col>
                <validation-observer ref="attendanceGuideForm" v-slot="{ invalid }">
                  <b-row class="mb-2">
                    <b-col>
                      <label class="cj-label">Convênio</label>
                      <validation-provider name="convênio" :rules="{ required: true }" v-slot="{ errors }">
                        <b-form-input type="text" v-model="attendanceGuideForm.health_plan" :disabled="true" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                    <b-col>
                      <label class="cj-label">Data do atendimento</label>
                      <b-form-input type="text" v-model="attendanceGuideForm.start_datetime" :disabled="true" autocomplete="off"></b-form-input>
                    </b-col>
                  </b-row>
                  <b-row class="mb-3">
                    <b-col>
                      <label class="cj-label">Profissional</label>
                      <b-form-input type="text" v-model="attendanceGuideForm.professional.name" :disabled="true" autocomplete="off"></b-form-input>
                    </b-col>
                    <b-col>
                      <label class="cj-label">Forma de faturamento</label>
                      <validation-provider name="forma de faturamento" :rules="{ required: true }" v-slot="{ errors }">
                        <multiselect v-model="attendanceGuideForm.bill_type" :options="billTypeOptions" track-by="name" label="name" :preselectFirst="false" :allowEmpty="false" :showLabels="false" :searchable="true" :disabled="(attendanceGuideForm.invoices.length > 0)" placeholder="Selecione" :class="{ 'error': errors.length > 0 }"></multiselect>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                  </b-row>
                </validation-observer>
                <hr>
                <validation-observer v-if="attendanceGuideForm.pending && user != null && (attendanceGuideForm.invoices.length === 0 || (user.person.type !== 'SECRETARY' && attendanceGuideForm.bill_type != null && attendanceGuideForm.bill_type.value === 'accomplished_procedures'))" ref="attendanceGuideItemForm" v-slot="{ invalid }">
                  <b-col class="p-3 mb-3 background-color-whisper">
                    <b-row v-if="attendanceGuideForm.is_dentist" class="mb-2">
                      <b-col>
                        <label class="cj-label">Dente/Área</label>
                        <validation-provider name="dente/área" :rules="{ required: true }" v-slot="{ errors }">
                          <multiselect v-model="attendanceGuideForm.item.tooth" :options="teeth" :showLabels="false" :searchable="true" placeholder="Dente/Área" :class="{ 'error': errors.length > 0 }"></multiselect>
                          <span class="cj-error">{{ errors[0] }}</span>
                        </validation-provider>
                      </b-col>
                      <b-col>
                        <label class="cj-label">Face(s)</label>
<!--                        <validation-provider name="face" :rules="{ required: (typeof attendanceGuideForm.item.tooth === 'number') || (attendanceGuideForm.item.tooth != null && !isNaN(attendanceGuideForm.item.tooth)) }" v-slot="{ errors }">-->
                        <validation-provider name="face(s)" :rules="{ required: false }" v-slot="{ errors }">
                          <multiselect v-model="attendanceGuideForm.item.faces" :options="faces" :showLabels="false" :searchable="true" :multiple="true" placeholder="Face(s)" :class="{ 'error': errors.length > 0 }"></multiselect>
                          <span class="cj-error">{{ errors[0] }}</span>
                        </validation-provider>
                      </b-col>
                    </b-row>
                    <b-row class="mb-3">
                      <b-col cols="12" md="6">
                        <label class="cj-label">Procedimento</label>
                        <validation-provider name="procedimento" :rules="{ required: true }" v-slot="{ errors }">
                          <multiselect ref="multiselectProcedure" :preserveSearch="true" v-model="attendanceGuideForm.item.procedure" :options="attendanceGuideProcedures" track-by="name" label="name" :loading="isLoadingAttendanceGuideProcedures" :internal-search="false" :options-limit="20" :limit="5" :max-height="200" @search-change="findAttendanceGuideProcedures" :showLabels="false" placeholder="Selecione um procedimento" :class="{ 'error': errors.length > 0 }">
                            <template slot="noOptions">
                              <div>
                                Digite para pesquisar procedimentos...
                              </div>
                            </template>
                            <template slot="noResult" v-if="!isLoadingAttendanceGuideProcedures">
                              <div>
                                Nenhum procedimento encontrado...
                              </div>
                            </template>
                          </multiselect>
                          <span class="cj-error">{{ errors[0] }}</span>
                        </validation-provider>
                      </b-col>
                      <b-col>
                        <label class="cj-label">Quantidade</label>
                        <validation-provider name="quantidade" :rules="{ required: true }" v-slot="{ errors }">
                          <b-form-input v-model="attendanceGuideForm.item.amount" type="number" min="1" step="1" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                          <span class="cj-error">{{ errors[0] }}</span>
                        </validation-provider>
                      </b-col>
                      <b-col>
                        <label class="cj-label">Valor</label>
                        <validation-provider name="valor" :rules="{ required: true }" v-slot="{ errors }">
                          <money v-model="attendanceGuideForm.item.value" class="form-control" :class="{ 'error': errors.length > 0 }"></money>
                          <span class="cj-error">{{ errors[0] }}</span>
                        </validation-provider>
                      </b-col>
                    </b-row>
                    <b-row class="mb-2 justify-content-end">
                      <b-col cols="auto">
                        <b-button variant="success" @click="addItemToAttendanceGuide">Adicionar</b-button>
                      </b-col>
                    </b-row>
                  </b-col>
                </validation-observer>

                <table class="table table-responsive w-100 d-block d-md-table table-centered table-cj">
                  <thead>
                  <tr>
                    <th v-if="attendanceGuideForm.is_dentist">Dente/Área</th>
                    <th v-if="attendanceGuideForm.is_dentist">Face(s)</th>
                    <th>Procedimento</th>
                    <th>Quantidade</th>
                    <th>Valor</th>
                    <th class="text-center">Realizado?</th>
                    <th class="text-center">Faturado?</th>
                    <th class="text-center"></th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(item, index) of attendanceGuideForm.items" :key="'attendanceGuideFormItems-'+index">
                    <td v-if="attendanceGuideForm.is_dentist">{{ item.tooth != null ? item.tooth : '-' }}</td>
                    <td v-if="attendanceGuideForm.is_dentist">{{ item.faces != null ? item.faces : '-' }}</td>
                    <td>{{ item.procedure.name }}</td>
                    <td>{{ item.amount }}</td>
                    <td>R$ {{ formatPrice(item.value) }}</td>
                    <td class="text-center">
                      <div v-if="!attendanceGuideForm.pending || (attendanceGuideForm.bill_type != null && attendanceGuideForm.bill_type.value === 'accomplished_procedures' && item.attendance_guide_invoice_id != null) || (user != null && (user.person.type === 'SECRETARY' && attendanceGuideForm.bill_type != null && attendanceGuideForm.bill_type.value === 'accomplished_procedures' && attendanceGuideForm.invoices.length > 0))" class="pretty p-switch p-fill">
                        {{item.accomplished ? 'Sim' : 'Não'}}
                      </div>
                      <div v-else class="pretty p-switch p-fill">
                        <input type="checkbox" v-model="item.accomplished" />
                        <div class="state p-success">
                          <label></label>
                        </div>
                      </div>
                    </td>
                    <td class="text-center">
                      {{item.attendance_guide_invoice_id != null ? 'Sim' : 'Não'}}
                    </td>
                    <td class="text-center">
                      <b-button v-if="item.attendance_guide_invoice_id == null && user != null && (user.person.type !== 'SECRETARY' || attendanceGuideForm.invoices.length === 0)" size="sm" variant="danger" @click="removeItemFromAttendanceGuide(index)"><i class="far fa-trash-alt"></i></b-button>
                    </td>
                  </tr>
                  <tr v-if="attendanceGuideForm.items.length == 0">
                    <td :colspan="(attendanceGuideForm.is_dentist ? 8 : 6)" class="text-center">
                      Nenhum item adicionado à guia.
                    </td>
                  </tr>
                  </tbody>
                  <tfoot v-if="attendanceGuideForm.items.length > 0">
                  <tr>
                    <td v-if="attendanceGuideForm.is_dentist"></td>
                    <td v-if="attendanceGuideForm.is_dentist"></td>
                    <td></td>
                    <td class="text-right">Total:</td>
                    <td>R$ {{ formatPrice(attendanceGuideForm.items.reduce((total, item) => total + item.value, 0)) }}</td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  </tfoot>
                </table>

                <div v-if="attendanceGuideForm.invoices.length > 0">
                  <label class="text1">Faturas</label>
                </div>
                <table v-if="attendanceGuideForm.invoices.length > 0" class="table table-responsive w-100 d-block d-md-table table-centered table-cj">
                  <thead>
                  <tr>
                    <th>Lançamento</th>
                    <th>Vencimento</th>
                    <th>Valor</th>
                    <th>Status</th>
                    <th>Baixa</th>
                    <th class="text-center"></th>
                  </tr>
                  </thead>
                  <tbody>
                    <template v-for="(invoice, index) in attendanceGuideForm.invoices">
                      <tr v-for="(transaction, transactionIndex) of invoice.transactions" :key="index + '-' + transactionIndex">
                        <td>{{ moment(transaction.registration_date).format('DD/MM/YYYY') }}</td>
                        <td>{{ transaction.charge_date != null ? moment(transaction.charge_date).format('DD/MM/YYYY') : '-' }}</td>
                        <td>R$ {{ formatPrice(invoice.transaction.value) }}</td>
                        <td>{{ !transaction.discharged?'Não ':'' }} Recebido</td>
                        <td>{{ transaction.discharge_date != null ? moment(transaction.discharge_date).format('DD/MM/YYYY') : '' }}</td>
                        <td class="text-center">
                          <router-link v-if="transaction != null" tag="button" class="btn btn-primary btn-sm" :to="'/financeiro/contas-a-receber/'+transaction.id"><i class="far fa-eye mr-1"></i> Ver fatura</router-link>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                  <tfoot v-if="attendanceGuideForm.items.length > 0">
                  <tr>
                    <td></td>
                    <td class="text-right">Total:</td>
                    <td>R$ {{ formatPrice(attendanceGuideForm.invoices.reduce((total, invoice) => total + invoice.transactions.reduce((totalTransaction, transaction) => totalTransaction + transaction.value, 0), 0)) }}</td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td></td>
                    <td class="text-right">Comissão:</td>
                    <td>R$ {{ formatPrice(attendanceGuideForm.professional.commission_percentage * attendanceGuideForm.invoices.reduce((total, invoice) => total + invoice.transactions.reduce((totalTransaction, transaction) => totalTransaction + transaction.value, 0), 0) / 100.0) }}</td>
                    <td></td>
                    <td></td>
                    <td></td>
                  </tr>
                  </tfoot>
                </table>
              </b-col>
            </template>
            <template slot="modal-footer">
              <b-button size="sm" @click="$bvModal.hide('attendance-guide-modal')">Fechar</b-button>
              <b-button v-if="attendanceGuideForm.pending && user != null && (helpers.isOwner() || (user.person.type == 'SECRETARY' && attendanceGuideForm.invoices.length === 0) || user.person.type == 'PROFESSIONAL' || helpers.checkPermission('attendance-guides', attendanceGuideForm.id != null ? 'can_edit' : 'can_add', true))" size="sm" variant="success" @click="saveAttendanceGuide(false)">Salvar</b-button>
              <b-button v-if="helpers.planHasPermission('financial') && attendanceGuideForm.pending && attendanceGuideForm.bill_type != null && (attendanceGuideForm.bill_type.value === 'accomplished_procedures' || attendanceGuideForm.invoices.length === 0) && user != null && (helpers.isOwner() || user.person.type == 'SECRETARY' || user.person.type == 'PROFESSIONAL' || helpers.checkPermission('attendance-guides', attendanceGuideForm.id != null ? 'can_edit' : 'can_add', true))" size="sm" variant="primary" @click="billAttendanceGuide()">Faturar</b-button>
            </template>
          </b-modal>

          <b-modal id="prescription-form-modal" size="xl" hide-header hide-footer no-close-on-backdrop>
            <template slot="default">
              <iframe v-if="currentPrescription != null" :src="currentPrescription.embed_url"></iframe>
            </template>
          </b-modal>

          <b-modal id="reminder-modal" class="reminder-modal" size="lg" :modalClass="'reminder-modal'" @hidden="resetReminderModal">
            <template slot="modal-header">
              <div class="w-100 d-flex justify-content-between">
                <div>
                  Lembrete para {{ personForm.name }}
                </div>
              </div>
            </template>
            <template slot="default">
              <b-col>
                <validation-observer ref="reminderForm" v-slot="{ invalid }">
                  <b-row class="mb-3">
                    <b-col>
                      <label class="cj-label">Data do lembrete</label>
                      <validation-provider name="data do lembrete" :rules="{ required: true }" v-slot="{ errors }">
                        <date-picker name="date" v-model="reminderForm.date" v-mask="'##/##/####'" :disabled="!((personForm.id == null && canAdd) || (personForm.id != null && canEdit))" :config="datePickerOptions" :class="{ 'error': errors.length > 0 }" autocomplete="off"></date-picker>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                    <b-col>
                      <validation-provider name="tipo" :rules="{ required: true }" v-slot="{ errors }">
                        <label class="cj-label">Tipo</label>
                        <multiselect v-model="reminderForm.type" :options="reminderTypes" track-by="name" label="name" :preselectFirst="true" :showLabels="false" :allowEmpty="false" :searchable="false" :disabled="!((personForm.id == null && canAdd) || (personForm.id != null && canEdit))" placeholder="Selecione" :class="{ 'error': errors.length > 0 }"></multiselect>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                  </b-row>
                  <b-row class="mb-3">
                    <b-col>
                      <label class="cj-label">Descrição</label>
                      <validation-provider name="descrição" v-slot="{ errors }">
                        <b-form-input type="text" v-model="reminderForm.description" :disabled="!((personForm.id == null && canAdd) || (personForm.id != null && canEdit))" maxlength="200" autocomplete="off"></b-form-input>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                  </b-row>
                </validation-observer>
              </b-col>
            </template>
            <template slot="modal-footer">
              <b-button size="sm" @click="$bvModal.hide('reminder-modal')">Fechar</b-button>

              <b-button-group size="sm">
                <b-button variant="danger" v-if="reminderForm.id != null" @click="deleteReminder(reminderForm)">Remover</b-button>
                <b-button size="sm" variant="success" @click="saveReminder">Salvar</b-button>
              </b-button-group>
            </template>
          </b-modal>

        </b-form-row>
        <validation-observer ref="personForm" v-slot="{ invalid }">
          <b-row class="mb-3" v-show="!preview">
            <b-col cols="12" class="mt-n3 mb-3" v-if="personForm.id != null && $route.path != '/informacoes-pessoais'">
              <a class="cj-label" @click="goBack" href="#"><i class="fa fa-long-arrow-left mr-1"></i>Voltar</a>
            </b-col>
            <b-col cols="12">
              <div class="box-cj">
                <div class="header">
                  <p class="title">Informações pessoais</p>
                </div>
                <div class="content">
                  <b-row v-if="personForm.type == 'PATIENT' || personForm.type == 'PROFESSIONAL'">
                    <div class="photo-container">
                      <div id="personPhoto" class="person-photo rounded" title="Foto" @click="$refs.fileInput.$el.childNodes[0].click()"></div>
                      <b-button class="delete-photo" size="sm" variant="danger" v-if="((personForm.id == null && canAdd) || (personForm.id != null && canEdit)) && (currentPhoto || photoFile || personForm.photo)" @click="removePhoto"><i class="far fa-trash-alt"></i></b-button>
                      <label class="cj-label d-block">Selecionar foto</label>
                      <b-form-file class="d-block" style="width: 1px; height: 1px;opacity: 0" v-model="photoFile" accept=".jpg, .png" placeholder="" ref="fileInput" @input="photoChanged" :disabled="!((personForm.id == null && canAdd) || (personForm.id != null && canEdit))"></b-form-file>
                    </div>
                    <b-col v-if="personForm.type == 'PATIENT'">
                      <label class="cj-label">Cód. Interno</label>
                      <b-form-input type="text" v-model="personForm.internal_code" :disabled="!((personForm.id == null && canAdd) || (personForm.id != null && canEdit))" autocomplete="off"></b-form-input>
                    </b-col>
                    <b-col>
                      <label class="cj-label">Nome</label>
                      <validation-provider name="nome" :rules="{ required: true }" v-slot="{ errors }">
                        <b-form-input type="text" v-model="personForm.name" :disabled="!((personForm.id == null && canAdd) || (personForm.id != null && canEdit))" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                    <b-col>
                      <label class="cj-label">CPF</label>
                      <validation-provider name="CPF" :rules="{ cpf: true }" v-slot="{ errors }">
                        <b-form-input type="tel" v-model="personForm.document" :class="{ 'error': errors.length > 0 }" autocomplete="off" v-mask="['###.###.###-##']" :disabled="!((personForm.id == null && canAdd) || (personForm.id != null && canEdit))"></b-form-input>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                    <b-col v-if="personForm.type == 'PROFESSIONAL'">
                      <label class="cj-label">Indicador na agenda</label>
                      <b-form-input type="color" v-model="personForm.indicator_color" :disabled="!((personForm.id == null && canAdd) || (personForm.id != null && canEdit))"></b-form-input>
                    </b-col>
                  </b-row>
                  <b-row v-else class="mb-2">
                    <b-col>
                      <label class="cj-label">Nome</label>
                      <validation-provider name="nome" :rules="{ required: true }" v-slot="{ errors }">
                        <b-form-input type="text" v-model="personForm.name" :disabled="!((personForm.id == null && canAdd) || (personForm.id != null && canEdit))" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                    <b-col>
                      <label class="cj-label">CPF</label>
                      <validation-provider name="CPF" :rules="{ cpf: true }" v-slot="{ errors }">
                        <b-form-input type="tel" v-model="personForm.document" :class="{ 'error': errors.length > 0 }" autocomplete="off" v-mask="['###.###.###-##']" :disabled="!((personForm.id == null && canAdd) || (personForm.id != null && canEdit))"></b-form-input>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                  </b-row>
                  <b-row class="mb-2">
                    <b-col>
                      <label class="cj-label">E-mail</label>
                      <validation-provider name="e-mail" :rules="{ required: (personForm.type == 'PROFESSIONAL' || personForm.type == 'SECRETARY' || personForm.type == 'COORDINATOR'), email: true }" v-slot="{ errors }">
                        <b-form-input type="email" v-model="personForm.email" :disabled="!((personForm.id == null && canAdd) || (personForm.id != null && canEdit))" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                    <b-col>
                      <label class="cj-label">Celular</label>
                      <b-form-input type="tel" v-model="personForm.cellphone" v-mask="'(##) #####-####'" :disabled="!((personForm.id == null && canAdd) || (personForm.id != null && canEdit))" autocomplete="off"></b-form-input>
                    </b-col>
                    <b-col>
                      <label class="cj-label">Telefone</label>
                      <b-form-input type="tel" v-model="personForm.telephone" v-mask="'(##) ####-####'" :disabled="!((personForm.id == null && canAdd) || (personForm.id != null && canEdit))" autocomplete="off"></b-form-input>
                    </b-col>
                    <b-col>
                      <label class="cj-label">Sexo</label>
                      <multiselect v-model="personForm.gender" :options="genderOptions" track-by="name" label="name" :preselect-first="true" :showLabels="false" :allow-empty="false" :searchable="false" :disabled="!((personForm.id == null && canAdd) || (personForm.id != null && canEdit))"></multiselect>
                    </b-col>
                  </b-row>
                  <b-row class="mb-2">
                    <b-col>
                      <label class="cj-label">Data de Nascimento</label>
                      <date-picker name="date" v-model="personForm.birthday" v-mask="'##/##/####'" :disabled="!((personForm.id == null && canAdd) || (personForm.id != null && canEdit))" :config="datePickerOptions"></date-picker>
                    </b-col>
                    <template v-if="personForm.type == 'PATIENT'">
                      <b-col>
                        <label class="cj-label">Convênio</label>
                        <multiselect v-model="personForm.health_plan" :options="healthPlans" track-by="name" label="name" :preselect-first="true" :showLabels="false" :allow-empty="false" :searchable="false" :disabled="!((personForm.id == null && canAdd) || (personForm.id != null && canEdit))" placeholder="Convênio"></multiselect>
                      </b-col>
                      <b-col>
                        <label class="cj-label">Número da Carteira</label>
                        <b-form-input type="tel" v-model="personForm.card_number" v-mask="'########################################'" :disabled="!((personForm.id == null && canAdd) || (personForm.id != null && canEdit))" autocomplete="off"></b-form-input>
                      </b-col>
                    </template>
                    <template v-else-if="personForm.type == 'PROFESSIONAL'">
                      <b-col>
                        <label class="cj-label">Conselho Profissional</label>
                        <validation-provider name="conselho profissional" :rules="{ required: personForm.enable_professional_digital_prescriptions }" v-slot="{ errors }">
                          <b-form-input type="text" v-model="personForm.professional_registration.council" :disabled="!((personForm.id == null && canAdd) || (personForm.id != null && canEdit))" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                          <span class="cj-error">{{ errors[0] }}</span>
                        </validation-provider>
                      </b-col>
                      <b-col>
                        <label class="cj-label">Estado do Conselho</label>
                        <validation-provider name="estado do conselho" :rules="{ required: personForm.enable_professional_digital_prescriptions, length: 2 }" v-slot="{ errors }">
                          <b-form-input type="text" v-model="personForm.professional_registration.state" :disabled="!((personForm.id == null && canAdd) || (personForm.id != null && canEdit))" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                          <span class="cj-error">{{ errors[0] }}</span>
                        </validation-provider>
                      </b-col>
                      <b-col>
                        <label class="cj-label">Número do Registro</label>
                        <validation-provider name="número do registro" :rules="{ required: personForm.enable_professional_digital_prescriptions }" v-slot="{ errors }">
                          <b-form-input type="text" v-model="personForm.professional_registration.number" :disabled="!((personForm.id == null && canAdd) || (personForm.id != null && canEdit))" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                          <span class="cj-error">{{ errors[0] }}</span>
                        </validation-provider>
                      </b-col>
                    </template>
                    <template v-else>
                      <b-col></b-col>
                      <b-col></b-col>
                      <b-col></b-col>
                    </template>
                  </b-row>
                  <b-row class="mb-2" v-if="personForm.type == 'PROFESSIONAL'">
                    <b-col>
                      <validation-provider name="% de comissão" :rules="{ required: true, valueLowerOrEqual100: true }" v-slot="{ errors }">
                        <label class="cj-label">% de comissão</label>
                        <money v-model="personForm.commission_percentage" prefix="" suffix=" %" maxlength="7" class="form-control mb-2" :disabled="!((personForm.id == null && canAdd) || (personForm.id != null && canEdit))" :class="{ 'error': errors.length > 0 }" autocomplete="off"></money>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                    <b-col></b-col>
                    <b-col></b-col>
                    <b-col></b-col>
                  </b-row>
                  <b-row class="mb-2">
                    <b-col>
                      <label class="cj-label">Observações</label>
                      <b-textarea rows="5" v-model="personForm.notes" :disabled="!((personForm.id == null && canAdd) || (personForm.id != null && canEdit))"></b-textarea>
                    </b-col>
                  </b-row>
                </div>
                <div class="footer" v-if="(personForm.id == null && canAdd) || (personForm.id != null && canEdit)">
                  <b-button variant="primary" class="mr-3" @click="savePerson" :disabled="!canPerformAction">Salvar</b-button>
                </div>
              </div>
            </b-col>
          </b-row>

          <div v-if="personForm.type == 'PROFESSIONAL'">
            <b-form-row class="mb-3">
              <b-col cols="6">
                <div class="box-cj">
                  <div class="header">
                    <p class="title">Convênios</p>
                  </div>
                  <div class="content">
                    <b-row>
                      <b-col>
                        <label class="cj-label">Convênios</label>
                        <multiselect v-model="personForm.health_plans" :options="healthPlans" track-by="name" label="name" :preselect-first="false" :showLabels="false" :allow-empty="false" :searchable="true" :multiple="true" :disabled="!((personForm.id == null && canAdd) || (personForm.id != null && canEdit))" placeholder="Convênios"></multiselect>
                      </b-col>
                    </b-row>
                  </div>
                  <div class="footer" v-if="(personForm.id == null && canAdd) || (personForm.id != null && canEdit)">
                    <b-button variant="primary" class="mr-3" @click="savePerson" :disabled="!canPerformAction">Salvar</b-button>
                  </div>
                </div>
              </b-col>
              <b-col cols="6">
                <div class="box-cj">
                  <div class="header">
                    <p class="title">Especialidades</p>
                  </div>
                  <div class="content">
                    <b-row>
                      <b-col>
                        <label class="cj-label">Especialidades</label>
                        <multiselect v-model="personForm.specialities" :options="specialities" track-by="name" label="name" :preselect-first="false" :showLabels="false" :allow-empty="false" :searchable="true" :multiple="true" :disabled="!((personForm.id == null && canAdd) || (personForm.id != null && canEdit))" placeholder="Especialidade"></multiselect>
                      </b-col>
                    </b-row>
                  </div>
                  <div class="footer" v-if="(personForm.id == null && canAdd) || (personForm.id != null && canEdit)">
                    <b-button variant="primary" class="mr-3" @click="savePerson" :disabled="!canPerformAction">Salvar</b-button>
                  </div>
                </div>
              </b-col>
            </b-form-row>
          </div>

          <b-row class="mb-3" v-if="user != null && user.person.client.enable_digital_prescriptions == 1 && personForm.type == 'PROFESSIONAL'">
            <b-col cols="12">
              <div class="box-cj">
                <div class="header">
                  <div class="d-flex justify-content-between align-items-center">
                    <p class="title">Emissão de receituário digital</p>

                    <div>
                      <div class="pretty p-switch p-fill">
                        <input type="checkbox" v-model="personForm.enable_professional_digital_prescriptions" :disabled="!((personForm.id == null && canAdd) || (personForm.id != null && canEdit))" />
                        <div class="state p-success">
                          <label></label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="footer" v-if="(personForm.id == null && canAdd) || (personForm.id != null && canEdit)">
                  <b-button variant="primary" class="mr-3" @click="savePerson" :disabled="!canPerformAction">Salvar</b-button>
                </div>
              </div>
            </b-col>
          </b-row>

          <b-row class="mb-3" v-show="!preview && personForm.type == 'PATIENT'">
            <b-col cols="12">
              <div class="box-cj">
                <div class="header">
                  Endereço
                </div>
                <div class="content">
                  <b-row class="mb-2">
                    <b-col>
                      <label class="cj-label">CEP</label>
                      <b-form-input type="tel" v-model="personForm.address.zip_code" v-mask="'#####-###'" :disabled="!((personForm.id == null && canAdd) || (personForm.id != null && canEdit))" v-on:blur="findCep(personForm.address.zip_code)" autocomplete="off"></b-form-input>
                    </b-col>
                    <b-col cols="8">
                      <label class="cj-label">Endereço</label>
                      <b-form-input type="text" v-model="personForm.address.address" ref="address" :disabled="!((personForm.id == null && canAdd) || (personForm.id != null && canEdit))" autocomplete="off"></b-form-input>
                    </b-col>
                    <b-col>
                      <label class="cj-label">Número</label>
                      <b-form-input type="tel" v-model="personForm.address.number" ref="number" :disabled="!((personForm.id == null && canAdd) || (personForm.id != null && canEdit))" autocomplete="off"></b-form-input>
                    </b-col>
                  </b-row>
                  <b-row class="mb-2">
                    <b-col>
                      <label class="cj-label">Complemento</label>
                      <b-form-input type="text" v-model="personForm.address.complement" :disabled="!((personForm.id == null && canAdd) || (personForm.id != null && canEdit))" autocomplete="off"></b-form-input>
                    </b-col>
                    <b-col>
                      <label class="cj-label">Bairro</label>
                      <b-form-input type="text" v-model="personForm.address.neighborhood" :disabled="!((personForm.id == null && canAdd) || (personForm.id != null && canEdit))" autocomplete="off"></b-form-input>
                    </b-col>
                    <b-col>
                      <label class="cj-label">Cidade</label>
                      <b-form-input type="text" v-model="personForm.address.city" :disabled="!((personForm.id == null && canAdd) || (personForm.id != null && canEdit))" autocomplete="off"></b-form-input>
                    </b-col>
                    <b-col>
                      <label class="cj-label">Estado</label>
                      <b-form-input type="text" v-model="personForm.address.state" :disabled="!((personForm.id == null && canAdd) || (personForm.id != null && canEdit))" autocomplete="off"></b-form-input>
                    </b-col>
                  </b-row>
                </div>
                <div class="footer" v-if="(personForm.id == null && canAdd) || (personForm.id != null && canEdit)">
                  <b-button variant="primary" class="mr-3" @click="savePerson">Salvar</b-button>
                </div>
              </div>
            </b-col>

            <b-col cols="12">
              <div class="box-cj">
                <div class="header">
                  <p class="title">Informações do(a) responsável</p>
                </div>
                <div class="content">
                  <b-row class="mb-2">
                    <b-col>
                      <label class="cj-label">Nome</label>
                      <b-form-input type="text" v-model="personForm.responsible_name" :disabled="!((personForm.id == null && canAdd) || (personForm.id != null && canEdit))" autocomplete="off"></b-form-input>
                    </b-col>
                    <b-col>
                      <label class="cj-label">CPF</label>
                      <b-form-input type="text" v-model="personForm.responsible_document" :disabled="!((personForm.id == null && canAdd) || (personForm.id != null && canEdit))" autocomplete="off"></b-form-input>
                    </b-col>
                    <b-col>
                      <label class="cj-label">Parentesco</label>
                      <b-form-input type="text" v-model="personForm.responsible_kinship" :disabled="!((personForm.id == null && canAdd) || (personForm.id != null && canEdit))" autocomplete="off"></b-form-input>
                    </b-col>
                  </b-row>
                  <b-row class="mb-2">
                    <b-col>
                      <label class="cj-label">E-mail</label>
                      <b-form-input type="email" v-model="personForm.responsible_email" :disabled="!((personForm.id == null && canAdd) || (personForm.id != null && canEdit))" autocomplete="off"></b-form-input>
                    </b-col>
                    <b-col>
                      <label class="cj-label">Telefone</label>
                      <b-form-input type="text" v-model="personForm.responsible_phone" :disabled="!((personForm.id == null && canAdd) || (personForm.id != null && canEdit))" autocomplete="off"></b-form-input>
                    </b-col>
                    <b-col>
                      <label class="cj-label">Notas</label>
                      <b-form-input type="text" v-model="personForm.responsible_notes" :disabled="!((personForm.id == null && canAdd) || (personForm.id != null && canEdit))" autocomplete="off"></b-form-input>
                    </b-col>
                  </b-row>
                </div>
                <div class="footer" v-if="(personForm.id == null && canAdd) || (personForm.id != null && canEdit)">
                  <b-button variant="primary" class="mr-3" @click="savePerson" :disabled="!canPerformAction">Salvar</b-button>
                </div>
              </div>
            </b-col>

            <b-col cols="12">
              <div class="box-cj">
                <div class="header">
                  <p class="title">Informações do(a) responsável 2</p>
                </div>
                <div class="content">
                  <b-row class="mb-2">
                    <b-col>
                      <label class="cj-label">Nome</label>
                      <b-form-input type="text" v-model="personForm.responsible2_name" :disabled="!((personForm.id == null && canAdd) || (personForm.id != null && canEdit))" autocomplete="off"></b-form-input>
                    </b-col>
                    <b-col>
                      <label class="cj-label">CPF</label>
                      <b-form-input type="text" v-model="personForm.responsible2_document" :disabled="!((personForm.id == null && canAdd) || (personForm.id != null && canEdit))" autocomplete="off"></b-form-input>
                    </b-col>
                    <b-col>
                      <label class="cj-label">Parentesco</label>
                      <b-form-input type="text" v-model="personForm.responsible2_kinship" :disabled="!((personForm.id == null && canAdd) || (personForm.id != null && canEdit))" autocomplete="off"></b-form-input>
                    </b-col>
                  </b-row>
                  <b-row class="mb-2">
                    <b-col>
                      <label class="cj-label">E-mail</label>
                      <b-form-input type="email" v-model="personForm.responsible2_email" :disabled="!((personForm.id == null && canAdd) || (personForm.id != null && canEdit))" autocomplete="off"></b-form-input>
                    </b-col>
                    <b-col>
                      <label class="cj-label">Telefone</label>
                      <b-form-input type="text" v-model="personForm.responsible2_phone" :disabled="!((personForm.id == null && canAdd) || (personForm.id != null && canEdit))" autocomplete="off"></b-form-input>
                    </b-col>
                    <b-col>
                      <label class="cj-label">Notas</label>
                      <b-form-input type="text" v-model="personForm.responsible2_notes" :disabled="!((personForm.id == null && canAdd) || (personForm.id != null && canEdit))" autocomplete="off"></b-form-input>
                    </b-col>
                  </b-row>
                </div>
                <div class="footer" v-if="(personForm.id == null && canAdd) || (personForm.id != null && canEdit)">
                  <b-button variant="primary" class="mr-3" @click="savePerson" :disabled="!canPerformAction">Salvar</b-button>
                </div>
              </div>
            </b-col>
          </b-row>

          <b-row class="mb-3" v-if="personForm.type == 'PROFESSIONAL' || personForm.type == 'SECRETARY' || personForm.type == 'COORDINATOR'">
            <b-col cols="12">
              <div class="box-cj">
                <div class="header">
                  <p class="title">Dados do usuário</p>
                </div>
                <div class="content">
                  <b-row>
                    <b-col>
                      <label class="cj-label">E-mail (Login)</label>
                      <b-form-input type="email" v-model="personForm.email" readonly></b-form-input>
                    </b-col>
                    <b-col>
                      <label class="cj-label">Senha</label>
                      <validation-provider name="senha" :rules="{ required: ((personForm.type == 'PROFESSIONAL' || personForm.type == 'SECRETARY' || personForm.type == 'COORDINATOR') && personForm.id == null) }" v-slot="{ errors }">
                        <b-form-input type="password" v-model="personForm.password" :disabled="!((personForm.id == null && canAdd) || (personForm.id != null && canEdit))" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                    <b-col>
                      <label class="cj-label">Confirme a senha</label>
                      <validation-provider name="confirme sua senha" :rules="{ required: ((personForm.type == 'PROFESSIONAL' || personForm.type == 'SECRETARY' || personForm.type == 'COORDINATOR') && personForm.id == null) }" v-slot="{ errors }">
                        <b-form-input type="password" v-model="personForm.password_confirmation" :disabled="!((personForm.id == null && canAdd) || (personForm.id != null && canEdit))" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                  </b-row>
                </div>
                <div class="footer" v-if="(personForm.id == null && canAdd) || (personForm.id != null && canEdit)">
                  <b-button variant="primary" class="mr-3" @click="savePerson" :disabled="!canPerformAction">Salvar</b-button>
                  <b-button variant="danger" v-if="personForm.id != null && $route.path == '/informacoes-pessoais'" @click="logoutOtherDevices" :disabled="!canPerformAction">Sair de outros dispositivos</b-button>
                </div>
              </div>
            </b-col>
          </b-row>

          <b-row class="mb-3" v-show="!preview && personForm.id != null && personForm.type != 'PATIENT'">

          </b-row>

          <div v-if="personForm.type == 'PROFESSIONAL' || personForm.type == 'SECRETARY' || personForm.type == 'COORDINATOR'">
            <b-row v-if="$route.path != '/informacoes-pessoais' && helpers.checkPermission('permissions', 'can_see')">
              <b-col cols="12">
                <div class="box-cj">
                  <div class="header">
                    <p class="title">Permissões de Acesso</p>
                  </div>
                  <div class="content">
                    <table class="table table-striped table-responsive table-hover table-bordered m-0" style="display: table;">
                      <thead>
                        <th>Módulo</th>
                        <th class="text-center">Pode visualizar?</th>
                        <th class="text-center">Pode adicionar?</th>
                        <th class="text-center">Pode editar?</th>
                        <th class="text-center">Pode remover?</th>
                      </thead>
                      <tbody>
                      <tr v-for="permission in permissions" :key="permission.module">
                        <td>{{ helpers.getModuleName(permission.module) }}</td>
                        <td class="text-center">
                          <div class="pretty p-switch p-fill">
                            <input type="checkbox" v-model="permission.can_see" :disabled="!((personForm.id == null && canAdd) || (personForm.id != null && canEdit)) || (personForm.id != null && helpers.getOwnerId() == personForm.id) || !helpers.checkPermission('permissions', 'can_manage')" />
                            <div class="state p-success">
                              <label></label>
                            </div>
                          </div>
                        </td>
                        <td class="text-center" v-if="permission.module != 'permissions' && permission.module != 'client-data' && permission.module != 'subscription'">
                          <div class="pretty p-switch p-fill" v-if="permission.module != 'dashboard' && permission.module != 'cash-flow'">
                            <input type="checkbox" v-model="permission.can_add" :disabled="!((personForm.id == null && canAdd) || (personForm.id != null && canEdit)) || (personForm.id != null && helpers.getOwnerId() == personForm.id) || !helpers.checkPermission('permissions', 'can_manage')" />
                            <div class="state p-success">
                              <label></label>
                            </div>
                          </div>
                          <div v-else>
                            -
                          </div>
                        </td>
                        <td class="text-center" v-if="permission.module != 'permissions' && permission.module != 'client-data' && permission.module != 'subscription'">
                          <div class="pretty p-switch p-fill" v-if="permission.module != 'dashboard' && permission.module != 'cash-flow'">
                            <input type="checkbox" v-model="permission.can_edit" :disabled="!((personForm.id == null && canAdd) || (personForm.id != null && canEdit)) || (personForm.id != null && helpers.getOwnerId() == personForm.id) || !helpers.checkPermission('permissions', 'can_manage')" />
                            <div class="state p-success">
                              <label></label>
                            </div>
                          </div>
                          <div v-else>
                            -
                          </div>
                        </td>
                        <td class="text-center" v-if="permission.module != 'permissions' && permission.module != 'client-data' && permission.module != 'subscription'">
                          <div class="pretty p-switch p-fill" v-if="permission.module != 'dashboard' && permission.module != 'cash-flow'">
                            <input type="checkbox" v-model="permission.can_remove" :disabled="!((personForm.id == null && canAdd) || (personForm.id != null && canEdit)) || (personForm.id != null && helpers.getOwnerId() == personForm.id) || !helpers.checkPermission('permissions', 'can_manage')" />
                            <div class="state p-success">
                              <label></label>
                            </div>
                          </div>
                          <div v-else>
                            -
                          </div>
                        </td>
                        <td class="text-center" v-if="permission.module == 'permissions' || permission.module == 'client-data' || permission.module == 'subscription'" colspan="3">
                          <div class="pretty p-switch p-fill">
                            <input type="checkbox" v-model="permission.can_manage" :disabled="!((personForm.id == null && canAdd) || (personForm.id != null && canEdit)) || (personForm.id != null && helpers.getOwnerId() == personForm.id) || !helpers.checkPermission('permissions', 'can_manage')" />
                            <div class="state p-success">
                              <label></label>
                            </div>
                          </div>
                        </td>
                      </tr>
                      </tbody>
                    </table>
                  </div>
                  <div class="footer" v-if="canManage && helpers.checkPermission('permissions', 'can_manage')">
                    <b-button variant="primary" class="mr-3" @click="savePerson" :disabled="!canPerformAction">Salvar</b-button>
                  </div>
                </div>
              </b-col>
            </b-row>
          </div>

          <b-form-row v-show="$route.path != '/informacoes-pessoais' && !preview && personForm.id != null && !helpers.checkOwner(personForm.id)">
            <b-col cols="6">
              <div class="box-cj">
                <div class="header">
                  <p class="title">Unificar {{ termPlural }}</p>
                </div>
                <div class="content">
                  <validation-observer ref="unifyForm" v-slot="{ invalid }">
                    <b-row class="mb-2">
                      <b-col>
                        <label class="cj-label">{{ termSingular }}</label>
                        <validation-provider :name="termSingular"  v-slot="{ errors }">
                          <multiselect ref="multiselectPeople" :preserveSearch="true" v-model="unifyForm.person" :options="people" track-by="name" label="name" :loading="isLoadingPeople" :internal-search="false" :options-limit="20" :limit="5" :limit-text="limitPeople" :max-height="200" @search-change="findPeople" :showLabels="false" :placeholder="'Selecione um '+(termSingular.charAt(0).toUpperCase() + termSingular.slice(1))" :class="{ 'error': errors.length > 0 }">
                            <template slot="noOptions">
                              <div>
                                Digite para pesquisar seus {{ termPlural }}...
                              </div>
                            </template>
                            <template slot="noResult" v-if="!isLoadingPeople">
                              <div>
                                Nenhum {{ termSingular}} encontrado...
                              </div>
                            </template>
                          </multiselect>
                          <span class="cj-error">{{ errors[0] }}</span>
                        </validation-provider>
                      </b-col>
                      <b-col>
                        <label class="cj-label">Informe o nome do {{ termSingular }}</label>
                        <validation-provider :name="'nome d'+letter+' '+termSingular"  v-slot="{ errors }">
                          <b-form-input type="text" v-model="unifyForm.verification" :disabled="unifyForm.person == null" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                          <span class="cj-error">{{ errors[0] }}</span>
                        </validation-provider>
                      </b-col>
                    </b-row>
                  </validation-observer>
                </div>
                <div class="footer" v-if="(personForm.id == null && canAdd) || (personForm.id != null && canEdit)">
                  <b-button variant="warning" class="mr-3" @click="unifyPerson" block :disabled="(unifyForm.person != null && unifyForm.person.name != unifyForm.verification) || (unifyForm.person == null)">Unificar {{ termSingular }}</b-button>
                </div>
              </div>
            </b-col>

            <b-col cols="6" v-if="canRemove">
              <div class="box-cj">
                <div class="header">
                  <p class="title">Remover {{ termSingular }}</p>
                </div>
                <div class="content">
                  <validation-observer ref="unifyForm" v-slot="{ invalid }">
                    <b-row class="mb-2">
                      <b-col>
                        <label class="cj-label">Informe o nome do {{ termSingular }}</label>
                        <validation-provider :name="'nome d'+letter+' '+termSingular"  v-slot="{ errors }">
                          <b-form-input type="text" v-model="deleteForm.verification" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                          <span class="cj-error">{{ errors[0] }}</span>
                        </validation-provider>
                      </b-col>
                    </b-row>
                  </validation-observer>
                </div>
                <div class="footer" v-if="(personForm.id == null && canAdd) || (personForm.id != null && canEdit)">
                  <b-button variant="danger" class="mr-3" @click="deletePerson" block :disabled="(personForm.name != deleteForm.verification)">Remover {{ termSingular }}</b-button>
                </div>
              </div>
            </b-col>
          </b-form-row>
        </validation-observer>
      </div>
    </b-container>

    <div class="printable" v-if="user && (user.person.type == 'PROFESSIONAL' || user.person.type == 'COORDINATOR' || (user.person.type == 'SECRETARY' && typeof user.person.can_see_forms != 'undefined' && user.person.can_see_forms)) && formSelected != null">
      <div class="print-header">
        <img :src="logo" width="100" :alt="formSelected.unit.display_name">
        <div class="print-client-info">
          <h1 class="mt-0 mb-1">{{ formSelected.unit.display_name }}</h1>
          <div>{{ formSelected.unit.display_document }}</div>
          <div v-if="formSelected.unit.display_telephone != null && formSelected.unit.display_telephone != ''"><i class="fal fa-phone fa-flip-horizontal mr-1"></i> {{ formSelected.unit.display_telephone }}</div>
        </div>
        <div class="print-client-info text-right">
          <div v-if="formSelected.unit.display_cellphone != null && formSelected.unit.display_cellphone != ''"><i class="fab fa-whatsapp mr-1"></i> {{ formSelected.unit.display_cellphone }}</div>
          <div><i class="fal fa-map-marker-alt mr-1"></i> {{ buildFormSelectedAddress(formSelected.unit) }}</div>
        </div>
      </div>
      <div class="text-center mb-5">
        <h3 class="text-center">{{ formSelected.name }} de {{ personForm.name }}</h3>
        <h4 class="text-center">Gerado em {{ moment(formSelected.created_at).format('DD/MM/YYYY HH:mm:ss') }} por {{ formSelected.professional }}</h4>
        <h5 class="text-center">Impresso em <b>{{ moment().format('DD/MM/YYYY HH:mm')}}</b> por <b>{{ user.name }}</b></h5>
      </div>
      <div class="mt-3 fields">
        <div v-for="field in getFieldsInOrder(formSelected.fields)" :key="'printableFormSelectedFields-'+field.id" class="field" :class="'field-'+field.cols">
          <FormField :field="field" :readonly="true" :printable="true"></FormField>
        </div>
      </div>
    </div>

    <div class="printable" v-if="user && (user.person.type == 'PROFESSIONAL' || user.person.type == 'COORDINATOR' || (user.person.type == 'SECRETARY' && typeof user.person.can_see_forms != 'undefined' && user.person.can_see_forms)) && formSelected == null && quoteForm.id == null">
      <div class="print-header">
        <img :src="logo" width="100" :alt="user.person.client.default_unit.display_name">
        <div class="print-client-info">
          <h1 class="mt-0 mb-1">{{ user.person.client.default_unit.display_name }}</h1>
          <div>{{ user.person.client.default_unit.display_document }}</div>
          <div v-if="user.person.client.default_unit.display_telephone != null && user.person.client.default_unit.display_telephone != ''"><i class="fal fa-phone fa-flip-horizontal mr-1"></i> {{ user.person.client.default_unit.display_telephone }}</div>
        </div>
        <div class="print-client-info text-right">
          <div v-if="user.person.client.default_unit.display_cellphone != null && user.person.client.default_unit.display_cellphone != ''"><i class="fab fa-whatsapp mr-1"></i> {{ user.person.client.default_unit.display_cellphone }}</div>
          <div><i class="fal fa-map-marker-alt mr-1"></i> {{ buildFormSelectedAddress(user.person.client.default_unit) }}</div>
        </div>
      </div>
      <template v-for="(attendance, index) in attendances">
        <template v-for="form in attendance.forms">
          <div :key="'printableAttendanceForms-'+form.id+index" class="mt-3 mb-3">
            <div class="text-center mb-5">
              <img src="@/assets/images/consulta-ja-logo.png" height="50" class="mb-3" alt="" v-if="index == 0">
              <h3 class="text-center">{{ form.name }} de {{ personForm.name }}</h3>
              <h4 class="text-center">Atendido em {{ moment(attendance.start_datetime).format('DD/MM/YYYY HH:mm:ss') }} por {{ attendance.professional.name  }}</h4>
              <h5 class="text-center" v-if="index == 0">Impresso em <b>{{ moment().format('DD/MM/YYYY HH:mm')}}</b> por <b>{{ user.name }}</b></h5>
            </div>
            <div class="mt-3 fields">
              <div v-for="field in getFieldsInOrder(form.fields)" :key="'printableAttendanceFormFields-'+field.id" class="field" :class="'field-'+field.cols">
                <FormField :field="field" :readonly="true" :printable="true"></FormField>
              </div>
            </div>
            <hr>
          </div>
        </template>
      </template>
    </div>

    <div class="printable" v-if="user && quoteForm.id != null">
      <div class="print-header">
        <img :src="logo" width="100" :alt="user.person.client.default_unit.display_name">
        <div class="print-client-info">
          <h1 class="mt-0 mb-1">{{ user.person.client.default_unit.display_name }}</h1>
          <div>{{ user.person.client.default_unit.display_document }}</div>
          <div v-if="user.person.client.default_unit.display_telephone != null && user.person.client.default_unit.display_telephone != ''"><i class="fal fa-phone fa-flip-horizontal mr-1"></i> {{ user.person.client.default_unit.display_telephone }}</div>
        </div>
        <div class="print-client-info text-right">
          <div v-if="user.person.client.default_unit.display_cellphone != null && user.person.client.default_unit.display_cellphone != ''"><i class="fab fa-whatsapp mr-1"></i> {{ user.person.client.default_unit.display_cellphone }}</div>
          <div><i class="fal fa-map-marker-alt mr-1"></i> {{ buildFormSelectedAddress(user.person.client.default_unit) }}</div>
        </div>
      </div>
      <div class="text-center mb-5">
        <h3 class="text-center">Orçamento: {{ quoteForm.title }} de {{ personForm.name }}</h3>
        <h4 class="text-center">Gerado em {{ moment(quoteForm.created_at).format('DD/MM/YYYY HH:mm:ss') }}</h4>
        <h5 class="text-center">Impresso em <b>{{ moment().format('DD/MM/YYYY HH:mm')}}</b> por <b>{{ user.name }}</b></h5>
      </div>
      <div class="mt-0">
        <table class="table table-responsive w-100 d-block d-md-table table-centered table-cj mt-0">
          <thead>
            <tr>
              <th>Dente(s)</th>
              <th>Face(s)</th>
              <th>Procedimento</th>
              <th>Valor</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) of quoteForm.items" :key="'quoteFormItems-'+index">
              <td>{{ item.teeth.join(', ') }}</td>
              <td>{{ item.faces.join(', ') }}</td>
              <td>{{ item.procedure.name }}</td>
              <td>R$ {{ formatPrice(item.value) }}</td>
            </tr>
            <tr v-if="quoteForm.items.length == 0">
              <td colspan="5" class="text-center">
                Nenhum item adicionado ao orçamento.
              </td>
            </tr>
          </tbody>
          <tfoot v-if="quoteForm.items.length > 0">
            <tr>
              <td></td>
              <td></td>
              <td class="text-right">Total:</td>
              <td>R$ {{ formatPrice(quoteForm.items.reduce((total, item) => total + item.value, 0)) }}</td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  // import {compressToUTF16, decompressFromUTF16} from "lz-string";

  export default {
    data() {
      return {
        leavingPage: false,
        user: null,
        logo: '',

        termSingular: '',
        termPlural: '',
        url: '',
        letter: '',
        newTerm: '',
        module: '',
        preview: false,

        canSee: true,
        canAdd: true,
        canEdit: true,
        canRemove: true,
        canManage: true,
        canPerformAction: true,

        currentPhoto: null,
        photoFile: null,

        personForm: {
          id: null,
          enable_professional_digital_prescriptions: false,
          type: this.$route.meta.type,
          photo: null,
          delete_photo: false,
          name: '',
          internal_code: '',
          document: '',
          birthday: '',
          indicator_color: '#24a7f0',
          commission_percentage: 0,
          gender: '',
          email: '',
          telephone: '',
          cellphone: '',
          health_plan: '',
          card_number: '',
          notes: '',
          address: {
            id: null,
            zip_code: null,
            address: null,
            number: null,
            complement: null,
            neighborhood: null,
            city: null,
            state: null,
            country: 'Brazil'
          },
          responsible_name: '',
          responsible_document: '',
          responsible_kinship: '',
          responsible_email: '',
          responsible_phone: '',
          responsible_notes: '',
          responsible2_name: '',
          responsible2_document: '',
          responsible2_kinship: '',
          responsible2_email: '',
          responsible2_phone: '',
          responsible2_notes: '',
          password: '',
          password_confirmation: '',
          specialities: [],
          health_plans: [],
          professional_registration: {
            id: null,
            council: null,
            state: null,
            number: null
          }
        },

        appointments: [],
        attendances: [],
        quotes: [],
        reminders: [],
        units: [],

        appointmentAudits: [],

        transactionSummary: {
          paid: 0,
          overdue: 0,
          future: 0,
          total: 0,
          min_registration_date: this.moment().subtract(1, 'years').startOf('month').format('YYYY-MM-DD'),
          max_registration_date: this.moment().endOf('month').format('YYYY-MM-DD'),
        },
        attendanceGuides: [],

        billTypeOptions: [
          { value: 'accomplished_procedures', name: 'Por procedimento realizado' },
          { value: 'full_guide', name: 'Guia completa' }
        ],

        activeTab: 'past-appointments',
        showPastAppointments: true,
        futureAppointments: [],
        todayAppointments: [],
        attendanceGuideAppointment: null,
        attendanceGuideForm: {
          id: null,
          appointment_id: null,
          health_plan_id: null,
          start_datetime: '',
          internal_id: '',
          name: '',
          professional: {
            name: '',
            commission_percentage: 0,
            specialities: [],
          },
          is_dentist: false,
          health_plan: '',
          bill_type: null,
          authorization_code: '',
          pending: true,
          items: [],
          invoices: [],
          item: {
            id: null,
            attendance_guide_invoice_id: null,
            tooth: null,
            faces: null,
            procedure: null,
            amount: 1,
            value: 0,
            accomplished: false
          }
        },
        attendanceGuideProcedures: [],
        isLoadingAttendanceGuideProcedures: false,

        genderOptions: [
          { value: 'U', name: 'Não informado' },
          { value: 'M', name: 'Masculino' },
          { value: 'F', name: 'Feminino' }
        ],

        specialities: [],
        healthPlans: [],

        permissions: this.helpers.getModules(),

        datePickerOptions: {
          format: 'DD/MM/YYYY',
          useCurrent: false,
          locale: 'pt-br'
        },

        attendanceInProgress: null,
        attendanceStartDatetime: null,
        interval: null,
        timer: null,

        forms: [],
        attendanceForms: [],
        attendancePrescriptions: [],
        currentPrescription: null,

        formSelected: null,
        formSelectedShowNotes: false,
        formSelectedAttendanceId: null,
        formSelectedProfessionalId: null,
        formSelectedNote: '',

        quoteForm: {
          id: null,
          title: '',
          professional: null,
          status: '',
          items: [],
          item: {
            teeth: [],
            faces: [],
            procedure: null,
            value: 0,
            accomplished: false
          }
        },

        reminderForm: {
          id: null,
          type: null,
          description: '',
          date: '',
        },

        reminderTypes: [],
        professionals: [],
        procedures: [],
        isLoadingProcedures: false,

        teeth: ['Boca toda', 'Arcada Superior', 'Arcada Inferior', 11, 12, 13, 14, 15, 16, 17, 18, 21, 22, 23, 24, 25, 26, 27, 28, 31, 32, 33, 34, 35, 36, 37, 38, 41, 42, 43, 44, 45, 46, 47, 48, 51, 52, 53, 54, 55, 61, 62, 63, 64, 65, 71, 72, 73, 74, 75, 81, 82, 83, 84, 85],
        faces: ['Vestibular', 'Palatina', 'Lingual', 'Mesial', 'Distal', 'Oclusal', 'Incisal'],

        quoteStatus: ['Pendente', 'Aceito', 'Recusado'],

        people: [],
        isLoadingPeople: false,

        unifyForm: {
          person: null,
          verification: ''
        },

        deleteForm: {
          verification: ''
        },

        dateRangePickerPtBrLocale : {
          locale: 'pt-BR',
          direction: 'ltr',
          format: this.moment().localeData().longDateFormat('L'),
          separator: ' até ',
          applyLabel: 'Aplicar',
          cancelLabel: 'Cancelar',
          weekLabel: 'W',
          daysOfWeek: this.moment().localeData().weekdaysMin(),
          monthNames: this.moment().localeData().monthsShort()
        },

        hasMoreTimeline: false,

        appointmentsFilter: {
          dateTime: { startDate: null, endDate: null },
          quantity: 10
        }
      }
    },
    watch: {
      'appointmentsFilter.dateTime': {
        deep: true,
        handler() {
          this.appointmentsFilter.quantity = 10;
        }
      },
      'attendanceForms': {
        deep: true,
        handler(newValue) {
          if(this.attendanceInProgress != null) {
            // localStorage.setItem('attendanceForms_' + this.$route.params.id, compressToUTF16(JSON.stringify(newValue)));
            try {
              localStorage.setItem('attendanceForms_' + this.$route.params.id, JSON.stringify(newValue));
            } catch (err) {
              this.sentry.captureMessage(JSON.stringify(newValue));
              throw err;
            }
          }
        }
      },
      'attendancePrescriptions': {
        deep: true,
        handler(newValue) {
          if(this.attendanceInProgress != null) {
            localStorage.setItem('attendancePrescriptions_' + this.$route.params.id, JSON.stringify(newValue));
          }
        }
      },
      'attendanceGuideForm.item.procedure': {
        handler(newValue) {
          if(newValue != null) {
            this.attendanceGuideForm.item.value = newValue.procedure_value * this.attendanceGuideForm.item.amount;
          }
        }
      },
      'attendanceGuideForm.item.amount': {
        handler(newValue) {
          if(this.attendanceGuideForm.item.procedure != null) {
            this.attendanceGuideForm.item.value = this.attendanceGuideForm.item.procedure.procedure_value * newValue;
          }
        }
      }
    },
    async mounted () {
      this.user = JSON.parse(localStorage.getItem('user'));

      if(this.$route.path == '/informacoes-pessoais') {
        this.$route.meta.type = this.user.person.type;
        this.$route.params.id = this.user.person.id;
        this.personForm.type = this.user.person.type;
      }
      if(!this.user.person.client.enable_coordinator_profile) {
        this.permissions = this.permissions.filter(permission => (permission.module != 'coordinators'));
      }
      if(!this.user.person.client.directing_enabled) {
        this.permissions = this.permissions.filter(permission => (permission.module != 'directing-sectors'));
      }
      if(this.$route.meta.type != 'COORDINATOR') {
        this.permissions = this.permissions.filter(permission => (permission.module != 'attendance-guides'));
      }

      if(this.$route.meta.type == 'PROFESSIONAL') {
        this.termSingular = 'profissional';
        this.termPlural = 'profissionais';
        this.url = 'profissionais';
        this.letter = 'o';
        this.newTerm = 'cadastrar-profissional';
        this.module = 'professionals';
      } else if(this.$route.meta.type == 'SECRETARY') {
        this.termSingular = 'secretária';
        this.termPlural = 'secretárias';
        this.url = 'secretarias';
        this.letter = 'a';
        this.newTerm = 'cadastrar-secretaria';
        this.module = 'secretaries';
      } else if(this.$route.meta.type == 'COORDINATOR') {
        this.termSingular = 'coordenador';
        this.termPlural = 'coordenadores';
        this.url = 'coordenadores';
        this.letter = 'o';
        this.newTerm = 'cadastrar-coordenador';
        this.module = 'coordinators';
      } else {
        this.termSingular = 'paciente';
        this.termPlural = 'pacientes';
        this.url = 'pacientes';
        this.letter = 'o';
        this.newTerm = 'cadastrar-paciente';
        this.module = 'patients';
        if(!this.$route.query.editar) {
          this.preview = true;
        }
      }

      this.canSee = (this.helpers.isOwner() || this.$route.path == '/informacoes-pessoais')?true:this.helpers.checkPermission(this.module, 'can_see');
      this.canAdd = (this.helpers.isOwner() || this.$route.path == '/informacoes-pessoais')?true:this.helpers.checkPermission(this.module, 'can_add');
      this.canEdit = (this.helpers.isOwner() || this.$route.path == '/informacoes-pessoais')?true:this.helpers.checkPermission(this.module, 'can_edit');
      this.canRemove = (this.helpers.isOwner() || this.$route.path == '/informacoes-pessoais')?true:this.helpers.checkPermission(this.module, 'can_remove');
      this.canManage = (this.helpers.isOwner() || this.$route.path == '/informacoes-pessoais')?true:this.helpers.checkPermission(this.module, 'can_manage');

      if(this.canSee == false) {
        this.$swal('Desculpe', 'Você não tem permissão para acessar este módulo!', 'error');
        this.$router.push({ path: '/' }).catch(() => {});
        return;
      }

      this.eventBus.$emit('IS_LOADING', true);
      this.canPerformAction = false;

      this.logo = this.user.person.client.logo ? this.user.person.client.logo : ('https://via.placeholder.com/40x40/eaf1f4/11a6f3?text=' + this.userNameInitials);

      document.addEventListener('focusin', function (e) {
        let closest = e.target.closest('.swal2-input');
        if (closest !== null && closest !== undefined) {
          e.stopImmediatePropagation();
        }
      });

      await this.api.getPersonFormData({type: this.$route.meta.type}).then(res => {
        if(this.leavingPage) {
          return;
        }
        this.healthPlans = [];
        res.data.health_plans.forEach(health_plan => {
          this.healthPlans.push({ value: health_plan.id, name: health_plan.name });
        });
        this.professionals = [];
        res.data.professionals.forEach(professional => {
          this.professionals.push({value: professional.id, name: professional.name});
        });
        this.reminderTypes = [];
        res.data.reminder_types.forEach(reminderType => {
          this.reminderTypes.push({value: reminderType.id, name: reminderType.name});
        });
        this.specialities = [];
        res.data.specialities.forEach(speciality => {
          this.specialities.push({ value: speciality.id, name: speciality.name });
        });

        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Response Person Form Data', res);
      }).catch(err => {
        if(this.leavingPage) {
          return;
        }
        this.$swal('Ops...', 'Não conseguimos carregar os dados! Por favor, entre em contato com o suporte!', 'error');
        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
          console.log('Error Person Form Data', err.response);
      });

      if(this.$route.params.id != this.newTerm) {
        await this.api.getPerson(this.$route.params.id, {}).then(res => {
          this.canPerformAction = true;
          if(this.leavingPage) {
            return;
          }

          let personData = res.data;

          let gender = (personData.gender == null || typeof personData.gender == 'undefined') ? 'U' : personData.gender;
          let address = (personData.address == null) ? {
            id: null,
            zip_code: '',
            address: null,
            number: null,
            complement: null,
            neighborhood: null,
            city: null,
            state: null,
            country: 'Brazil'
          } : personData.address;
          let professionalRegistration = (personData.professional_registration == null) ? {
            id: null,
            council: null,
            state: null,
            number: null
          } : personData.professional_registration;

          this.personForm = {
            id: personData.id,
            enable_professional_digital_prescriptions: personData.enable_professional_digital_prescriptions == 1,
            type: personData.type,
            photo: null,
            delete_photo: false,
            name: personData.name,
            internal_code: personData.internal_code,
            document: personData.document,
            birthday: (this.moment(personData.birthday).isValid())?this.moment(personData.birthday).format('DD/MM/YYYY'):'',
            indicator_color: personData.indicator_color,
            commission_percentage: personData.commission_percentage,
            gender: this.genderOptions.find(g => g.value == gender),
            email: personData.email,
            telephone: personData.telephone,
            cellphone: personData.cellphone,
            health_plan: this.healthPlans.find(g => g.value == personData.health_plan_id),
            card_number: personData.card_number,
            notes: personData.notes,
            address: address,
            responsible_name: personData.responsible_name,
            responsible_document: personData.responsible_document,
            responsible_kinship: personData.responsible_kinship,
            responsible_email: personData.responsible_email,
            responsible_phone: personData.responsible_phone,
            responsible_notes: personData.responsible_notes,
            responsible2_name: personData.responsible2_name,
            responsible2_document: personData.responsible2_document,
            responsible2_kinship: personData.responsible2_kinship,
            responsible2_email: personData.responsible2_email,
            responsible2_phone: personData.responsible2_phone,
            responsible2_notes: personData.responsible2_notes,
            password: '',
            password_confirmation: '',
            specialities: [],
            health_plans: [],
            professional_registration: professionalRegistration
          };
          this.currentPhoto = personData.photo;
          // console.log(this.currentPhoto);
          this.updatePhoto();

          personData.health_plans.forEach(health_plan => {
            this.personForm.health_plans.push({value: health_plan.id, name: health_plan.name});
          });

          if(typeof personData.specialities != 'undefined') {
            personData.specialities.forEach(speciality => {
              this.personForm.specialities.push({value: speciality.id, name: speciality.name});
            });
          }

          personData.permissions.forEach(permission => {
            this.updatePermissionByModule(permission.module, permission);
          });

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Person', res);
        }).catch(err => {
          if(this.leavingPage) {
            return;
          }
          this.canPerformAction = true;
          this.eventBus.$emit('IS_LOADING', false);

          this.$swal('Ops...', 'Não conseguimos carregar este ' + this.termSingular + '! Por favor, entre em contato com o suporte!', 'error');
          this.$router.push({path: '/' + this.url}).catch(() => {});

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Person', err.response);
        });

        if(this.$route.meta.type == 'PATIENT') {
          this.getPatientExtraData();

          await this.api.getForms({ 'enableds':true }).then(res => {
            if(this.leavingPage) {
              return;
            }
            this.forms = [];
            res.data.forms.forEach(form => {
              form.fields = form.fields.map(field => {
                field.value = (field.default_value != null && field.default_value != '')?field.default_value:'';
                if(field.type == 'multiple-choice') {
                  field.value = (field.value.indexOf(';') > -1)?field.value.split(';'):(field.value !== '' ? [field.value] : []);
                }
                return field;
              });
              this.forms.push({ value: form.id, name: form.name, fields: this.getFieldsInOrder(form.fields) });
            });

            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Response Forms', res);
          }).catch(err => {
            if(this.leavingPage) {
              return;
            }
            this.$swal('Ops...', 'Não conseguimos carregar os seus modelos de prontuários! Por favor, entre em contato com o suporte!', 'error');
            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Error Forms', err.response);
          });
        }
      } else {
        this.preview = false;
        this.canPerformAction = true;
      }
      this.eventBus.$emit('IS_LOADING', false);

      if(this.user != null && this.user.person.type == 'PROFESSIONAL') {
        window.addEventListener('message', this.processPrescriptionEvent);
      }
    },
    methods: {
      async savePerson() {
        if(!this.canPerformAction)
          return false;

        this.canPerformAction = false;

        const isValid = await this.$refs.personForm.validate();
        if(!isValid) {
          this.canPerformAction = true;
          return false;
        }

        if(this.canManage) {
          let personData =  {
            id: this.personForm.id,
            enable_professional_digital_prescriptions: this.personForm.enable_professional_digital_prescriptions ? 1 : 0,
            type: this.personForm.type,
            photo: this.personForm.photo,
            delete_photo: this.personForm.delete_photo,
            name: this.personForm.name,
            internal_code: this.personForm.internal_code,
            document: this.personForm.document,
            birthday: this.personForm.birthday,
            indicator_color: this.personForm.indicator_color,
            commission_percentage: this.personForm.commission_percentage,
            gender: this.personForm.gender != null ? this.personForm.gender.value : null,
            email: this.personForm.email,
            telephone: this.personForm.telephone,
            cellphone: this.personForm.cellphone,
            health_plan_id: this.personForm.health_plan != null ? this.personForm.health_plan.value : null,
            card_number: this.personForm.card_number,
            notes: this.personForm.notes,
            address: {
              id: this.personForm.address.id,
              zip_code: this.personForm.address.zip_code,
              address: this.personForm.address.address,
              number: this.personForm.address.number,
              complement: this.personForm.address.complement,
              neighborhood: this.personForm.address.neighborhood,
              city: this.personForm.address.city,
              state: this.personForm.address.state,
              country: 'Brazil'
            },
            responsible_name: this.personForm.responsible_name,
            responsible_document: this.personForm.responsible_document,
            responsible_kinship: this.personForm.responsible_kinship,
            responsible_email: this.personForm.responsible_email,
            responsible_phone: this.personForm.responsible_phone,
            responsible_notes: this.personForm.responsible_notes,
            responsible2_name: this.personForm.responsible2_name,
            responsible2_document: this.personForm.responsible2_document,
            responsible2_kinship: this.personForm.responsible2_kinship,
            responsible2_email: this.personForm.responsible2_email,
            responsible2_phone: this.personForm.responsible2_phone,
            responsible2_notes: this.personForm.responsible2_notes,
            password: this.personForm.password,
            password_confirmation: this.personForm.password_confirmation,
            specialities: this.personForm.specialities.map(speciality => { return speciality.value; }),
            health_plans: this.personForm.health_plans.map(healthPlan => { return healthPlan.value; }),
            permissions: this.permissions,
            professional_registration: {
              id: this.personForm.professional_registration.id,
              council: this.personForm.professional_registration.council,
              state: this.personForm.professional_registration.state,
              number: this.personForm.professional_registration.number
            }
          };
          if(personData.enable_professional_digital_prescriptions == 1 && (this.isNullOrEmpty(personData.document) || this.isNullOrEmpty(personData.email))) {
            let missingFields = [];
            if(this.isNullOrEmpty(personData.document)) {
              missingFields.push('CPF');
            }
            if(this.isNullOrEmpty(personData.email)) {
              missingFields.push('e-mail');
            }
            missingFields = missingFields.join(' e ');

            this.$swal('Ops...', 'Você precisa preencher o ' + missingFields + ' para habilitar a emissão de receituário digital!', 'error');
            this.canPerformAction = true;
            return false;
          }

          if (personData.password != personData.password_confirmation) {
            this.$swal('Ops...', 'As senhas digitadas não conferem!', 'error');
            this.canPerformAction = true;
            return false;
          }

          this.eventBus.$emit('IS_LOADING', true);
          if (this.personForm.id == null) {
            this.api.storePerson(personData).then(res => {
              this.eventBus.$emit('IS_LOADING', false);
              this.canPerformAction = true;

              if (res.status == 201) {
                this.$swal('Uhull \\o/', 'O ' + this.termSingular + ' foi cadastrad' + this.letter + ' com sucesso!', 'success').then(() => {
                  this.$router.push({path: '/' + this.url}).catch(() => {});
                });
              } else {
                this.$swal('Ops...', 'Ocorreu um erro ao cadastrar ' + this.letter + ' ' + this.termSingular + '! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
              }

              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Response Store Person', res);
            }).catch(err => {
              try {
                this.eventBus.$emit('IS_LOADING', false);
                this.canPerformAction = true;

                let msg = 'Não conseguimos cadastrar ' + this.letter + ' ' + this.termSingular + '! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';

                switch (err.response.status) {
                  case 422: msg = err.response.data.errors.join('\r\n'); break;
                }

                this.$swal('Ops...', msg, 'error');
              } catch(err2) {
                this.$swal('Erro', 'Por favor tire um print / foto e envie para nosso suporte:\n\nMethod: catchStorePerson\nError:'+err.toString(), 'warning');
                this.sentry.captureException(err);
              }
              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Error Store Person', err.response);
            });
          } else {
            this.api.updatePerson(this.personForm.id, personData).then(res => {
              this.eventBus.$emit('IS_LOADING', false);
              this.canPerformAction = true;

              if (res.status == 200) {
                this.$swal('Uhull \\o/', 'O ' + this.termSingular + ' foi atualizado com sucesso!', 'success').then(() => {
                  if(this.personForm.type == 'PATIENT') {
                    this.preview = true;
                  }
                  else {
                    this.$router.go();
                  }
                  // if(this.$route.path == '/informacoes-pessoais') {
                  //   this.$router.go();
                  // }
                  // else if(this.personForm.type == 'PATIENT') {
                  //   this.preview = true;
                  // }
                  // else {
                  //   this.$router.push({path: '/' + this.url}).catch(() => {});
                  // }
                });
              } else {
                this.$swal('Ops...', 'Ocorreu um erro ao atualizar ' + this.letter + ' ' + this.termSingular + '! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
              }

              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Response Update Person', res);
            }).catch(err => {
              try {
                this.eventBus.$emit('IS_LOADING', false);
                this.canPerformAction = true;

                let message = 'Não conseguimos atualizar ' + this.letter + ' ' + this.termSingular + '! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';

                switch (err.response.status) {
                  case 422: message = err.response.data.errors.join('\r\n'); break;
                }
                this.$swal('Ops...', message, 'error');
              } catch(err2) {
                this.$swal('Erro', 'Por favor tire um print / foto e envie para nosso suporte:\n\nMethod: catchUpdatePerson\nError:'+err.toString(), 'warning');
                this.sentry.captureException(err);
              }

              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Error Update Person', err.response);
            });
          }
        }
      },

      photoChanged() {
        this.personForm.photo = null;
        if (this.photoFile) {
          const scope = this;
          const reader = new FileReader();
          reader.onload = (event) => {
            scope.personForm.photo = event.target.result;
            scope.updatePhoto();
          };
          reader.readAsDataURL(this.photoFile);
        }
        else {
          this.updatePhoto();
        }
      },

      removePhoto() {
        this.$swal({
          title: 'Você tem certeza?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Remover foto',
          cancelButtonText: 'Cancelar',
          focusCancel: true
        }).then((res) => {
          if(res.value) {
            this.personForm.photo = null;
            this.currentPhoto = null;
            this.photoFile = null;
            this.personForm.delete_photo = true;
            this.updatePhoto();
          }
        });
      },

      updatePhoto() {
        let photo = '';
        if(this.personForm.photo != null) {
          photo = this.personForm.photo;
        } else if(this.currentPhoto != null) {
          photo = this.currentPhoto;
        } else {
          photo = 'https://via.placeholder.com/70x70/eaf1f4/11a6f3';
        }
        if(document.getElementById('personPhoto')) {
          document.getElementById('personPhoto').style.backgroundImage = 'url("' + photo + '")';
        }
        if(document.getElementById('personPhotoPreview')) {
          document.getElementById('personPhotoPreview').style.backgroundImage = 'url("' + photo + '")';
        }
      },

      async getPatientExtraData() {
        this.canPerformAction = false;

        await this.api.getPersonExtraData(this.$route.params.id).then(res => {
          this.canPerformAction = true;
          if(this.leavingPage) {
            return;
          }
          this.appointments = res.data.appointments;
          this.futureAppointments = this.appointments.filter(appointment => {
            return this.moment(appointment.start_datetime).isAfter(this.moment(), 'day');
          });
          this.todayAppointments = this.appointments.filter(appointment => {
            return this.moment(appointment.start_datetime).isSame(this.moment(), 'day');
          });
          let todayAppointmentsForAttendanceGuide = this.todayAppointments.filter(appointment => {
            return ['SHOWEDUP', 'ATTENDED', 'FINISHED'].includes(appointment.status);
          });
          this.attendanceGuideAppointment = todayAppointmentsForAttendanceGuide.length > 0 ? todayAppointmentsForAttendanceGuide[0] : null;
          this.todayAppointments = this.todayAppointments.filter(appointment => {
            return !['ATTENDED', 'FINISHED'].includes(appointment.status);
          });

          this.attendances = res.data.attendances;

          if(this.attendances.length > 0) {
            this.attendances.forEach(attendance => {
              if(attendance.end_datetime == null && (this.attendanceInProgress == null || (this.attendanceInProgress.professional_id !== this.user.person.id && attendance.professional_id === this.user.person.id))) {
                this.attendanceInProgress = attendance;
              }

              attendance.forms.map(form => {
                form.fields = form.fields.map(field => {
                  if(field.type == 'multiple-choice')
                    field.value = (field.value.indexOf(';') > -1)?field.value.split(';'):(field.value !== '' ? [field.value] : []);

                  return field;
                });
              });
            });
            if(this.attendanceInProgress != null) {
              this.attendanceStartDatetime = this.attendanceInProgress.start_datetime;
              this.interval = setInterval(this.setTimer, 1000);

              if(this.decompressAttendanceForm('attendanceForms_' + this.$route.params.id) != null)
                this.attendanceForms = this.decompressAttendanceForm('attendanceForms_' + this.$route.params.id);
              else if(this.decompressAttendanceForm('attendanceForms') != null) {
                this.attendanceForms = this.decompressAttendanceForm('attendanceForms');
                // localStorage.setItem('attendanceForms_' + this.$route.params.id, compressToUTF16(JSON.stringify(this.attendanceForms)));
                try {
                  localStorage.setItem('attendanceForms_' + this.$route.params.id, JSON.stringify(this.attendanceForms));
                } catch (err) {
                  this.sentry.captureMessage(JSON.stringify(this.attendanceForms));
                  throw err;
                }
                localStorage.removeItem('attendanceForms');
              }
              if(JSON.parse(localStorage.getItem('attendancePrescriptions_' + this.$route.params.id)) != null)
                this.attendancePrescriptions = JSON.parse(localStorage.getItem('attendancePrescriptions_' + this.$route.params.id));
              else if(JSON.parse(localStorage.getItem('attendancePrescriptions')) != null) {
                let attendancePrescriptionsString = localStorage.getItem('attendancePrescriptions');
                this.attendancePrescriptions = JSON.parse(attendancePrescriptionsString);
                localStorage.setItem('attendancePrescriptions_' + this.$route.params.id, attendancePrescriptionsString);
                localStorage.removeItem('attendancePrescriptions');
              }
            }
          }

          this.attendanceGuides = res.data.attendance_guides;

          this.quotes = res.data.quotes;
          this.reminders = res.data.reminders;
          this.units = res.data.units;

          if(this.helpers.planHasPermission('financial') && res.data.transaction_summary && res.data.transaction_summary.total > 0) {
            this.transactionSummary = res.data.transaction_summary;
          }


          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Person Extra Data', res);
        }).catch(err => {
          if(this.leavingPage) {
            return;
          }
          this.$router.push({path: '/' + this.url}).catch(() => {});

          this.$swal('Ops...', 'Não conseguimos carregar os dados deste ' + this.termSingular + '! Por favor, entre em contato com o suporte!', 'error');
          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Person Extra Data', err.response);
        });
      },

      getPermissionByModule(module) {
        return this.permissions.find(permission => {
          return permission.module == module;
        })
      },

      updatePermissionByModule(module, permissionData) {
        this.permissions = this.permissions.map(permission => {
          return (permission.module == module)?permissionData:permission;
        });
      },

      decompressAttendanceForm(key) {
        let attendanceFormsString = localStorage.getItem(key);
        if(attendanceFormsString == null) {
          return null;
        }
        if(attendanceFormsString.indexOf('{') === 0 || attendanceFormsString.indexOf('[') === 0) {
          try {
            let attendanceForms = JSON.parse(attendanceFormsString);
            if(attendanceForms != null) {
              return attendanceForms;
            }
          } catch(err) {
            console.log('parse attendance error', err);
          }
        }
        try {
          // return JSON.parse(decompressFromUTF16(attendanceFormsString));
          return JSON.parse(attendanceFormsString);
        } catch(err) {
          console.log('parse attendance error', err);
          return null;
        }
      },

      async startAttendanceAppointment(appointmentId) {
        if(!this.canPerformAction)
          return false;

        this.canPerformAction = false;

        await this.api.startAttendanceAppointment(appointmentId).then(res => {
          this.canPerformAction = true;
          if(this.leavingPage) {
            return;
          }

          if (res.status == 201) {
            let attendanceData = res.data;
            this.attendanceInProgress = attendanceData;
            this.attendanceStartDatetime = attendanceData.start_datetime;
            this.interval = setInterval(this.setTimer, 1000);

            if(attendanceData.appointment.telehealth && attendanceData.telehealth_attendance != null) {
              window.open(this.$router.resolve({path: '/pacientes/'+attendanceData.patient_id+'/teleconsulta/'+attendanceData.telehealth_attendance.id}).href);
            }
          }

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Start Attendance', res);
        }).catch(err => {
          this.canPerformAction = true;
          if(this.leavingPage) {
            return;
          }

          try {
            let msg = 'Não conseguimos iniciar o atendimento! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';

            switch (err.response.status) {
              case 400: msg = err.response.data.message; break;
              case 422: msg = err.response.data.errors.join('\r\n'); break;
            }

            this.$swal('Ops...', msg, 'error');
          } catch(err2) {
            this.$swal('Erro', 'Por favor tire um print / foto e envie para nosso suporte:\n\nMethod: catchStartAttendanceAppointment\nError:'+err.toString(), 'warning');
            this.sentry.captureException(err);
          }

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Start Attendance', err.response);
        });
      },

      async startAttendance() {
        if(!this.canPerformAction)
          return false;

        this.canPerformAction = false;

        await this.api.startPersonAttendance(this.$route.params.id).then(res => {
          this.canPerformAction = true;
          if(this.leavingPage) {
            return;
          }

          if (res.status == 201) {
            this.attendanceInProgress = res.data;
            this.attendanceStartDatetime = res.data.start_datetime;
            this.interval = setInterval(this.setTimer, 1000);
          }

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Start Attendance', res);
        }).catch(err => {
          this.canPerformAction = true;
          if(this.leavingPage) {
            return;
          }
          this.eventBus.$emit('IS_LOADING', false);
          this.canPerformAction = true;
          try {
            let msg = 'Não conseguimos iniciar o atendimento! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';

            switch (err.response.status) {
              case 400: msg = err.response.data.message; break;
              case 422: msg = err.response.data.errors.join('\r\n'); break;
            }

            this.$swal('Ops...', msg, 'error');

            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Error Start Attendance', err.response);
          } catch(err2) {
            this.$swal('Erro', 'Por favor tire um print / foto e envie para nosso suporte:\n\nMethod: catchStartPersonAttendance\nError:'+err.toString(), 'warning');
            this.sentry.captureException(err);
          }
        });
      },

      async endAttendance() {
        if(!this.canPerformAction)
          return false;

        const isValid = await this.$refs.attendanceForms.validate();
        if(!isValid) {
          return false;
        }

        this.$swal({
          title: 'Encerrar atendimento',
          text: 'Tem certeza que deseja encerrar este atendimento? As informações salvas não poderão ser alteradas.',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Encerrar',
          cancelButtonText: 'Cancelar',
          focusConfirm: true
        }).then((res) => {
          if(res.value) {
            this.canPerformAction = false;
            let attendanceData = {
              fields: [],
              prescriptions: []
            };

            this.attendanceForms.forEach(attendanceForm => {
              if(attendanceForm.form != null) {
                attendanceForm.form.fields.forEach(field => {
                  if(field.type == 'attachments') {
                    if(field.value != '') {
                      let attachments = [];
                      field.value.forEach(attachment => {
                        if(attachment.file != null) {
                          attachments.push({file:attachment.file,file_name:attachment.file_name,name:attachment.name != '' ? attachment.name : attachment.file_name});
                        }
                      });
                      if(attachments.length > 0)
                        attendanceData.fields.push({ id: field.id, type: field.type, value: attachments });
                    }
                  }
                  else if(field.value != '' || field.type == 'boolean')
                    attendanceData.fields.push({ id: field.id, type: field.type, value: (field.type == 'multiple-choice' && typeof field.value != 'string')?field.value.join(';'):field.value });
                });
              }
            });
            this.attendancePrescriptions.forEach(attendancePrescription => {
              attendanceData.prescriptions.push({ value: attendancePrescription.value });
            });

            this.api.endPersonAttendance(this.$route.params.id, attendanceData).then(res => {
              this.canPerformAction = true;
              if(this.leavingPage) {
                return;
              }

              if(this.interval != null)
                clearInterval(this.interval);

              this.attendanceForms = [];
              localStorage.removeItem('attendanceForms');
              localStorage.removeItem('attendanceForms_' + this.$route.params.id);
              this.attendancePrescriptions = [];
              localStorage.removeItem('attendancePrescriptions');
              localStorage.removeItem('attendancePrescriptions_' + this.$route.params.id);

              this.currentPrescription = null;
              this.attendanceInProgress = null;
              this.attendanceStartDatetime = null;
              this.interval = null;
              this.timer = null;

              this.getPatientExtraData();
              this.$forceUpdate();

              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Response End Attendance', res);
            }).catch(err => {
              try {
                this.canPerformAction = true;
                if(this.leavingPage) {
                  return;
                }

                let msg = 'Não conseguimos encerrar o atendimento! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';

                switch (err.response.status) {
                  case 400: msg = err.response.data.message; break;
                  case 422: msg = err.response.data.errors.join('\r\n'); break;
                }

                this.$swal('Ops...', msg, 'error');
              } catch(err2) {
                this.$swal('Erro', 'Por favor tire um print / foto e envie para nosso suporte:\n\nMethod: catchEndPersonAttendance\nError:'+err.toString(), 'warning');
                this.sentry.captureException(err);
              }
              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Error End Attendance', err.response);
            });
          }
        });
      },

      async logoutOtherDevices() {
        if(!this.canPerformAction)
          return false;

        this.$swal({
          title: 'Sair de outros dispositivos',
          text: 'Tem certeza de que deseja sair de todos os outros dispositivos?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Sim',
          cancelButtonText: 'Cancelar',
          focusConfirm: false
        }).then((res) => {
          if(res.value) {
            this.canPerformAction = false;
            this.eventBus.$emit('IS_LOADING', true);

            this.api.logoutOtherDevices().then(res => {
              this.canPerformAction = true;
              this.eventBus.$emit('IS_LOADING', false);

              this.$swal('Uhull \\o/', 'Você saiu de todos os outros dispositivos!', 'success');

              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Response LogoutOtherDevices', res);
            }).catch(err => {
              try {
                this.canPerformAction = true;

                let msg = 'Não conseguimos sair de outros despositivos! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';

                switch (err.response.status) {
                  case 400: msg = err.response.data.message; break;
                  case 422: msg = err.response.data.errors.join('\r\n'); break;
                }

                this.$swal('Ops...', msg, 'error');
              } catch(err2) {
                this.$swal('Erro', 'Por favor tire um print / foto e envie para nosso suporte:\n\nMethod: catchLogoutOtherDevices\nError:'+err.toString(), 'warning');
                this.sentry.captureException(err);
              }
              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Error LogoutOtherDevices', err.response);
            });
          } else {
            this.canPerformAction = true;
          }
        });
      },

      setTimer() {
        let now = this.moment();
        let diff = now.diff(this.moment(this.attendanceStartDatetime), 'seconds');

        this.timer = this.moment.duration(diff, 'seconds').format('hh:mm:ss', { trim: false });
      },

      getAvailableForms(currentForm) {
        let formsInUser = this.attendanceForms.map(attendanceForm => (attendanceForm.form != null && attendanceForm.form.hasOwnProperty('value'))?attendanceForm.form.value:null);

        return this.forms.filter(form => !formsInUser.includes(form.value) || (currentForm != null && form.value == currentForm.value));
      },

      showAddNewButton() {
        return (this.attendanceForms.length > 0 && this.attendanceForms.filter(attendanceForm => attendanceForm.form == null).length > 0)?false:true;
      },

      showAddNewPrescriptionButton() {
        return this.user != null && this.user.person.client.enable_digital_prescriptions == 1 && this.user.person.enable_professional_digital_prescriptions == 1 && this.attendanceInProgress != null;
      },

      addNewFormToAttendance() {
        if(!this.canPerformAction)
          return false;

        this.canPerformAction = false;

        this.attendanceForms.push({
          'id': this.helpers.uuidv4(),
          'form': null
        });
        this.canPerformAction = true;
      },

      removeAttendanceForm(attendanceFormId, formId) {
        this.attendanceForms = this.attendanceForms.filter(attendanceForm => attendanceForm.id != attendanceFormId);

        if(formId != null)
          this.forms.map(form => {
            if(form.value == formId)
              form.fields.forEach(field => {
                field.value = (field.default_value != null && field.default_value != '')?field.default_value:'';

                return field;
              });

            return form;
          });
      },

      removePrescription(prescription) {
        if(!this.canPerformAction || this.attendanceInProgress == null || this.user.person.professional_registration == null)
          return false;

        this.$swal({
          title: 'Você tem certeza?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Remover receituário',
          cancelButtonText: 'Cancelar',
          focusCancel: true
        }).then((res) => {
          if(res.value) {
            this.canPerformAction = false;

            this.eventBus.$emit('IS_LOADING', true);

            this.api.deletePrescription(prescription.external_id).then(res => {
              this.eventBus.$emit('IS_LOADING', false);
              this.canPerformAction = true;

              this.attendancePrescriptions = this.attendancePrescriptions.filter(attendancePrescription => attendancePrescription.id != prescription.id);

              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Response Delete Prescription', res);
            }).catch(err => {
              this.eventBus.$emit('IS_LOADING', false);
              this.canPerformAction = true;

              this.$swal('Ops...', 'Não conseguimos remover o receituário digital. Por favor, entre em contato com o suporte!', 'error');
              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Error Delete Prescription', err.response);
            });
          }
        });
      },

      showTab(tab) {
        if(this.activeTab != tab) {
          this.activeTab = tab;
          this.appointmentsFilter.quantity = 10;
        }
        this.showPastAppointments = tab === 'past-appointments';
      },

      getPersonTimeline() {
        let personTimeline = [];

        if(this.showPastAppointments) {
          this.attendances.forEach(attendance => {
            if(attendance.forms.length > 0 || attendance.prescriptions.length > 0) {
              personTimeline.push(this.moment(attendance.start_datetime).format('YYYY-MM-DD'));
            }
          });
        }

        this.appointments.forEach(appointment => {
          let appointmentDatetime = this.moment(appointment.start_datetime);
          if(!appointmentDatetime.isSame(this.moment(), 'day') || ['ATTENDED', 'FINISHED'].includes(appointment.status)) {
            if((this.showPastAppointments && appointmentDatetime.isSameOrBefore(this.moment(), 'day')) || (!this.showPastAppointments && appointmentDatetime.isAfter(this.moment(), 'day'))) {
              personTimeline.push(appointmentDatetime.format('YYYY-MM-DD'));
            }
          }
        });

        personTimeline = personTimeline.sort((a, b) => this.moment(b).diff(this.moment(a)));
        personTimeline = [... new Set(personTimeline)];


        if(this.appointmentsFilter.dateTime.startDate != null) {
          let startDate = this.moment(this.appointmentsFilter.dateTime.startDate),
            endDate = this.moment(this.appointmentsFilter.dateTime.endDate),
            filterRange = this.moment().range(startDate, endDate);

          personTimeline = personTimeline.filter(date => {
            return filterRange.contains(this.moment(date));
          });
        }
        if(!this.showPastAppointments) {
          personTimeline = personTimeline.reverse();
        }

        this.hasMoreTimeline = (personTimeline.length > this.appointmentsFilter.quantity);
        personTimeline = personTimeline.slice(0, this.appointmentsFilter.quantity);
        return personTimeline;
      },

      getPersonRemindersTimeline() {
        let personTimeline = [];

        this.reminders.forEach(reminder => {
          personTimeline.push(reminder.date);
        });

        // personTimeline = personTimeline.sort((a, b) => this.moment(b).diff(this.moment(a)));
        // personTimeline = [... new Set(personTimeline)];
        //
        // personTimeline = personTimeline.reverse();
        return personTimeline;
      },

      getInfoByDate(date) {
        date = this.moment(date);

        return {
          attendances: this.attendances.filter(attendance => {
            return this.moment(attendance.start_datetime).isSame(date, 'day');
          }),
          appointments: this.appointments.filter(appointment => {
            let appointmentDatetime = this.moment(appointment.start_datetime);
            return appointmentDatetime.isSame(date, 'day') && (!appointmentDatetime.isSame(this.moment(), 'day') || ['ATTENDED', 'FINISHED'].includes(appointment.status));
          })
        };
      },

      getRemindersByDate(date) {
        date = this.moment(date);
        return this.reminders.filter(reminder => {
          return this.moment(reminder.date).isSame(date, 'day');
        });
      },

      attendancesWithFormsOrPrescriptions(attendances) {
        let attendancesWithFormsOrPrescriptions = attendances.filter(attendance => {
          return attendance.forms.length > 0 || attendance.prescriptions.length > 0;
        });
        return attendancesWithFormsOrPrescriptions.length > 0;
      },

      async showAppointmentAudit(appointmentId) {
        if(!this.canPerformAction)
          return false;

        this.canPerformAction = false;
        this.eventBus.$emit('IS_LOADING', true);

        this.api.getAppointmentAudit(appointmentId).then(res => {
          this.eventBus.$emit('IS_LOADING', false);
          this.canPerformAction = true;

          this.appointmentAudits = res.data;
          this.$bvModal.show('audit-modal');

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Get Appointment Audit', res);
        }).catch(err => {
          try {
            this.eventBus.$emit('IS_LOADING', false);
            this.canPerformAction = true;

            let msg = 'Não conseguimos consultar o log de alterações deste agendamento! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';

            switch (err.response.status) {
              case 422: msg = err.response.data.errors.join('\r\n'); break;
            }

            this.$swal('Ops...', msg, 'error');
          } catch(err2) {
            this.$swal('Erro', 'Por favor tire um print / foto e envie para nosso suporte:\n\nMethod: catchGetAppointmentAudit\nError:'+err.toString(), 'warning');
            this.sentry.captureException(err);
          }

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Get Appointment Audit', err.response);
        });
      },

      showForm(form, attendance) {
        if(!this.canPerformAction)
          return false;

        this.canPerformAction = false;

        this.formSelected = form;
        this.formSelectedAttendanceId = attendance.id;
        this.formSelectedProfessionalId = attendance.professional_id;
        this.formSelectedShowNotes = form.notes.length > 0 && (((this.user.person.client.enable_coordinator_profile || this.user.person.client.enable_professional_notes) && this.user.person.type == 'PROFESSIONAL' && this.user.person.id == attendance.professional_id) || (this.user.person.client.enable_coordinator_profile && this.user.person.type == 'COORDINATOR'));
        this.formSelectedNote = '';
        this.formSelected.professional = attendance.professional.name;
        this.formSelected.created_at = attendance.start_datetime;

        this.formSelected.unit = attendance.unit_id != null ? this.units.find(g => g.id == attendance.unit_id) : this.user.person.client.default_unit;

        // this.formSelected.fields.map(field => {
        //   if(field.type == 'multiple-choice')
        //     field.value = (field.value.indexOf(';') > -1)?field.value.split(';'):(field.value !== '' ? [field.value] : []);
        //
        //   return field;
        // });

        this.$bvModal.show('form-modal');
        this.canPerformAction = true;
      },

      async saveFormNote() {
        if(!this.canPerformAction)
          return false;

        this.canPerformAction = false;

        const isValid = await this.$refs.noteForm.validate();
        if(!isValid) {
          this.canPerformAction = true;
          return false;
        }
        this.eventBus.$emit('IS_LOADING', true);

        let noteData = {
          form_id: this.formSelected.id,
          value: this.formSelectedNote
        };

        this.api.storeAttendanceFormNote(this.formSelectedAttendanceId, noteData).then(res => {
          this.eventBus.$emit('IS_LOADING', false);
          this.canPerformAction = true;

          this.formSelectedNote = '';
          this.$refs.noteForm.reset();
          this.formSelected.notes.push(res.data);

          this.$swal('Uhull \\o/', 'A anotação foi enviada com sucesso!', 'success');

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Store Form Note', res);
        }).catch(err => {
          this.eventBus.$emit('IS_LOADING', false);
          this.canPerformAction = true;

          let msg = 'Não conseguimos salvar esta anotação! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';

          switch (err.response.status) {
            case 422: msg = err.response.data.errors.join('\r\n'); break;
          }

          this.$swal('Ops...', msg, 'error');
          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Store Form Note', err.response);
        });
      },

      resetFormModal() {
        this.formSelected = null;
      },

      showReminderModal() {
        if(!this.canPerformAction)
          return false;

        this.canPerformAction = false;

        this.$bvModal.show('reminder-modal');
        this.canPerformAction = true;
      },

      showQuoteModal() {
        if(!this.canPerformAction)
          return false;

        this.canPerformAction = false;

        this.$bvModal.show('quote-modal');
        this.canPerformAction = true;
      },

      async addItemToQuote() {
        if(!this.canPerformAction)
          return false;

        this.canPerformAction = false;

        const isValid = await this.$refs.quoteItemForm.validate();
        if(!isValid) {
          this.canPerformAction = true;
          return false;
        }

        this.quoteForm.items.push(this.quoteForm.item);

        this.quoteForm.item = {
          teeth: [],
          faces: [],
          procedure: null,
          value: 0,
          accomplished: false
        };

        this.$refs.quoteItemForm.reset();
        this.canPerformAction = true;
      },

      async removeItemFromQuote(index) {
        this.quoteForm.items.splice(index, 1);
      },

      resetQuoteModal() {
        this.quoteForm = {
          id: null,
          title: '',
          professional: null,
          status: '',
          items: [],
          item: {
            teeth: [],
            faces: [],
            procedure: null,
            value: 0,
            accomplished: false
          }
        };
      },

      resetReminderModal() {
        this.reminderForm = {
          id: null,
          type: null,
          description: '',
          date: '',
        };
      },

      async saveQuote() {
        if(!this.canPerformAction)
          return false;

        this.canPerformAction = false;

        const isValid = await this.$refs.quoteForm.validate();
        if(!isValid) {
          this.canPerformAction = true;
          return false;
        }

        let quoteData = {
          id: this.quoteForm.id,
          title: this.quoteForm.title,
          professional_id: (this.quoteForm.professional != null)?this.quoteForm.professional.value:null,
          status: this.quoteForm.status,
          items: this.quoteForm.items.map(item => {
            return {
              id: item.id,
              teeth: item.teeth.join(', '),
              faces: item.faces.join(', '),
              procedure: item.procedure.value,
              value: item.value,
              accomplished: item.accomplished
            }
          })
        };

        if(this.quoteForm.id == null) {
          await this.api.storePersonQuote(this.personForm.id, quoteData).then(res => {
            this.canPerformAction = true;
            if(this.leavingPage) {
              return;
            }

            if (res.status == 201) {
              this.$bvModal.hide('quote-modal');
              this.getPatientExtraData();

              this.$swal('Uhull \\o/', 'O orçamento foi cadastrado com sucesso!', 'success');
            } else {
              this.$swal('Ops...', 'Ocorreu um erro ao cadastrar este orçamento! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
            }

            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Response Store Person Quote', res);
          }).catch(err => {
            this.canPerformAction = true;
            if(this.leavingPage) {
              return;
            }

            let msg = 'Não conseguimos cadastrar este orçamento! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';

            switch (err.response.status) {
              case 422: msg = err.response.data.errors.join('\r\n'); break;
            }

            this.$swal('Ops...', msg, 'error');
            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Error Store Person Quote', err.response);
          });
        } else {
          await this.api.updatePersonQuote(this.personForm.id, this.quoteForm.id, quoteData).then(res => {
            this.canPerformAction = true;
            if(this.leavingPage) {
              return;
            }

            if (res.status == 200) {
              this.$bvModal.hide('quote-modal');
              this.getPatientExtraData();

              this.$swal('Uhull \\o/', 'O orçamento foi atualizado com sucesso!', 'success');
            } else {
              this.$swal('Ops...', 'Ocorreu um erro ao atualizar este orçamento! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
            }

            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Response Update Person Quote', res);
          }).catch(err => {
            this.canPerformAction = true;
            if(this.leavingPage) {
              return;
            }

            let msg = 'Não conseguimos atualizar este orçamento! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';

            switch (err.response.status) {
              case 422: msg = err.response.data.errors.join('\r\n'); break;
            }

            this.$swal('Ops...', msg, 'error');
            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Error Update Person Quote', err.response);
          });
        }
      },

      async saveReminder() {
        if(!this.canPerformAction)
          return false;

        this.canPerformAction = false;

        const isValid = await this.$refs.reminderForm.validate();
        if(!isValid) {
          this.canPerformAction = true;
          return false;
        }

        let reminderData = {
          id: this.reminderForm.id,
          date: this.reminderForm.date,
          reminder_type_id: this.reminderForm.type.value,
          description: this.reminderForm.description,
        };

        this.eventBus.$emit('IS_LOADING', true);
        if(this.reminderForm.id == null) {
          await this.api.storePersonReminder(this.personForm.id, reminderData).then(res => {
            this.eventBus.$emit('IS_LOADING', false);
            this.canPerformAction = true;
            if(this.leavingPage) {
              return;
            }

            if (res.status == 201) {
              this.$bvModal.hide('reminder-modal');
              this.getPatientExtraData();

              this.$swal('Uhull \\o/', 'O lembrete foi cadastrado com sucesso!', 'success');
            } else {
              this.$swal('Ops...', 'Ocorreu um erro ao cadastrar este lembrete! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
            }

            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Response Store Person Reminder', res);
          }).catch(err => {
            this.eventBus.$emit('IS_LOADING', false);
            this.canPerformAction = true;
            if(this.leavingPage) {
              return;
            }

            let msg = 'Não conseguimos cadastrar este lembrete! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';

            switch (err.response.status) {
              case 422: msg = err.response.data.errors.join('\r\n'); break;
            }

            this.$swal('Ops...', msg, 'error');
            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Error Store Person Reminder', err.response);
          });
        } else {
          await this.api.updatePersonReminder(this.personForm.id, this.reminderForm.id, reminderData).then(res => {
            this.eventBus.$emit('IS_LOADING', false);
            this.canPerformAction = true;
            if(this.leavingPage) {
              return;
            }

            if (res.status == 200) {
              this.$bvModal.hide('reminder-modal');
              this.getPatientExtraData();

              this.$swal('Uhull \\o/', 'O lembrete foi atualizado com sucesso!', 'success');
            } else {
              this.$swal('Ops...', 'Ocorreu um erro ao atualizar este lembrete! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
            }

            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Response Update Person Reminder', res);
          }).catch(err => {
            this.eventBus.$emit('IS_LOADING', false);
            this.canPerformAction = true;
            if(this.leavingPage) {
              return;
            }

            let msg = 'Não conseguimos atualizar este lembrete! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';

            switch (err.response.status) {
              case 422: msg = err.response.data.errors.join('\r\n'); break;
            }

            this.$swal('Ops...', msg, 'error');
            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Error Update Person Reminder', err.response);
          });
        }
      },

      editReminder(reminder) {
        this.reminderForm = {
          id: reminder.id,
          date: this.moment(reminder.date).format('DD/MM/YYYY'),
          type: this.reminderTypes.find(reminderType => reminderType.value == reminder.reminder_type_id),
          description: reminder.description
        };

        this.$bvModal.show('reminder-modal');
      },

      editQuote(quote) {
        this.quoteForm = {
          id: quote.id,
          title: quote.title,
          professional: (quote.professional != null) ? {
              value: quote.professional.id,
              name: quote.professional.name
          } : null,
          status: quote.status,
          items: quote.items.map(item => {
            return {
              teeth: item.teeth.split(', '),
              faces: item.faces.split(', '),
              procedure: { value: item.item.id, name: item.item.code+' - '+item.item.description },
              value: item.value,
              accomplished: item.accomplished
            }
          }),
          item: {
            teeth: [],
            faces: [],
            procedure: null,
            value: 0,
            accomplished: false
          },
          created_at: quote.created_at
        };

        this.$bvModal.show('quote-modal');
      },

      deleteReminder(reminder) {
        this.$swal({
          title: 'Você tem certeza?',
          text: 'Esta ação não poderá ser desfeita!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Excluir lembrete',
          cancelButtonText: 'Cancelar',
          focusCancel: true
        }).then((res) => {
          if(res.value) {
            this.eventBus.$emit('IS_LOADING', true);
            this.canPerformAction = false;
            this.api.deletePersonReminder(this.personForm.id, reminder.id).then(res => {
              this.eventBus.$emit('IS_LOADING', false);
              this.canPerformAction = true;
              if (res.status == 204) {
                this.getPatientExtraData();

                this.$swal('Uhull \\o/', 'O lembrete foi excluído com sucesso!', 'success');
              } else {
                this.$swal('Ops...', 'Ocorreu um erro ao excluir o lembrete! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error')
              }
              this.$bvModal.hide('reminder-modal');

              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Response Delete Reminder', res);
            }).catch(err => {
              this.eventBus.$emit('IS_LOADING', false);
              this.canPerformAction = true;
              this.$swal('Ops...', 'Não conseguimos excluir este lembrete! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Error Delete Reminder', err.response);
            });
          }
        });
      },

      deleteQuote(quote) {
        this.$swal({
          title: 'Você tem certeza?',
          text: 'Esta ação não poderá ser desfeita!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Excluir orçamento',
          cancelButtonText: 'Cancelar',
          focusCancel: true
        }).then((res) => {
          if(res.value) {
            this.eventBus.$emit('IS_LOADING', true);
            this.canPerformAction = false;
            this.api.deletePersonQuote(this.personForm.id, quote.id).then(res => {
              this.eventBus.$emit('IS_LOADING', false);
              this.canPerformAction = true;
              if (res.status == 204) {
                this.getPatientExtraData();

                this.$swal('Uhull \\o/', 'O orçamento foi excluído com sucesso!', 'success');
              } else {
                this.$swal('Ops...', 'Ocorreu um erro ao excluir o orçamento! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error')
              }

              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Response Delete Quote', res);
            }).catch(err => {
              this.eventBus.$emit('IS_LOADING', false);
              this.canPerformAction = true;
              this.$swal('Ops...', 'Não conseguimos excluir este orçamento! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Error Delete Quote', err.response);
            });
          }
        });
      },

      deleteAttendanceGuide(attendanceGuide) {
        this.$swal({
          title: 'Você tem certeza?',
          text: 'Esta ação não poderá ser desfeita!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Excluir guia de atendimento',
          cancelButtonText: 'Cancelar',
          focusCancel: true
        }).then((res) => {
          if(res.value) {
            this.eventBus.$emit('IS_LOADING', true);
            this.canPerformAction = false;
            this.api.deleteAttendanceGuide(attendanceGuide.appointment_id, attendanceGuide.id).then(res => {
              this.eventBus.$emit('IS_LOADING', false);
              this.canPerformAction = true;
              if (res.status == 204) {
                this.getPatientExtraData();

                this.$swal('Uhull \\o/', 'A guia de atendimento foi excluída com sucesso!', 'success');
              } else {
                this.$swal('Ops...', 'Ocorreu um erro ao excluir a guia de atendimento! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error')
              }

              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Response Delete Attendance Guide', res);
            }).catch(err => {
              this.eventBus.$emit('IS_LOADING', false);
              this.canPerformAction = true;
              this.$swal('Ops...', 'Não conseguimos excluir esta guia de atendimento! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Error Delete Attendance Guide', err.response);
            });
          }
        });
      },

      findProcedures(query) {
        this.procedures = [];
        if(query.length >= 3 && !this.isLoadingProcedures) {
          this.isLoadingProcedures = true;
          this.api.tuss({ term: query }).then(res => {
            if(this.leavingPage) {
              return;
            }
            this.isLoadingProcedures = false;

            this.procedures = res.data.map(procedure => {
              return { value: procedure.id, name: procedure.code+' - '+procedure.description };
            });
          }).catch(err => {
            if(this.leavingPage) {
              return;
            }
            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Error Procedures', err.response);
          });
        }
      },

      formatPrice(value) {
        let val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      },

      print() {
        window.print();
      },

      getFieldsInOrder(fields) {
        fields = this.helpers.clone(fields);

        return fields.sort((a, b) => {
          if(a.order < b.order) return -1;
          if(a.order > b.order) return 1;
          return 0;
        });
      },

      limitPeople(qty) {
        return 'e '+qty+' outros pacientes';
      },

      findPeople(query) {
        this.people = [];
        if(query.length >= 3 && !this.isLoadingPeople) {
          this.isLoadingPeople = true;
          this.api.getPeople({type: this.$route.meta.type, name: query, different: this.personForm.id}).then(res => {
            if(this.leavingPage) {
              return;
            }
            this.isLoadingPeople = false;

            res.data.data.forEach(patient => {
              this.people.push({
                value: patient.id,
                name: patient.name
              });
            });
          }).catch(err => {
            if(this.leavingPage) {
              return;
            }
            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Error Patients', err.response);
          });
        }
      },

      async unifyPerson() {
        this.$swal({
          title: 'Você tem certeza?',
          text: 'Esta ação é irreversível!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Sim, unifique os cadastros!',
          cancelButtonText: 'Cancelar',
          focusCancel: true
        }).then((res) => {
          if(res.value) {
            this.eventBus.$emit('IS_LOADING', true);
            this.canPerformAction = false;

            let unifyData = {
              person: this.unifyForm.person.value,
              verification: this.unifyForm.verification
            };

            this.api.unifyPerson(this.personForm.id, unifyData).then(res => {
              this.eventBus.$emit('IS_LOADING', false);
              this.canPerformAction = true;

              if (res.status == 200) {
                this.$swal('Uhull \\o/', 'O ' + this.termSingular + ' foi unificado com sucesso!', 'success').then(() => {
                  this.$router.push({path: '/' + this.url}).catch(() => {});
                });
              } else {
                this.$swal('Ops...', 'Ocorreu um erro ao unificar ' + this.letter + ' ' + this.termSingular + '! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
              }

              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Response Unify Person', res);
            }).catch(err => {
              this.eventBus.$emit('IS_LOADING', false);
              this.canPerformAction = true;

              let msg = 'Não conseguimos unificar ' + this.letter + ' ' + this.termSingular + '! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';

              switch (err.response.status) {
                case 400: msg = err.response.data.message; break;
                case 422: msg = err.response.data.errors.join('\r\n'); break;
              }

              this.$swal('Ops...', msg, 'error');
              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Error Unify Person', err.response);
            });
          }
        });
      },

      async deletePerson() {
        this.$swal({
          title: 'Você tem certeza?',
          text: 'Esta ação é irreversível!',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Sim, remover ' + this.letter + ' ' + this.termSingular + '!',
          cancelButtonText: 'Cancelar',
          focusCancel: true
        }).then((res) => {
          if (res.value) {
            this.eventBus.$emit('IS_LOADING', true);
            this.canPerformAction = false;

            let deleteData = {
              verification: this.deleteForm.verification
            };

            this.api.deletePerson(this.personForm.id, deleteData).then(res => {
              this.eventBus.$emit('IS_LOADING', false);
              this.canPerformAction = true;

              if (res.status == 204) {
                this.$swal('Uhull \\o/', 'O ' + this.termSingular + ' foi removido com sucesso!', 'success').then(() => {
                  this.$router.push({path: '/' + this.url}).catch(() => {});
                });
              } else {
                this.$swal('Ops...', 'Ocorreu um erro ao remover ' + this.letter + ' ' + this.termSingular + '! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
              }

              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Response Destroy Person', res);
            }).catch(err => {
              this.eventBus.$emit('IS_LOADING', false);
              this.canPerformAction = true;

              let msg = 'Não conseguimos remover ' + this.letter + ' ' + this.termSingular + '! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';

              switch (err.response.status) {
                case 400: msg = err.response.data.message; break;
                case 422: msg = err.response.data.errors.join('\r\n'); break;
              }

              this.$swal('Ops...', msg, 'error');
              if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                console.log('Error Destroy Person', err.response);
            });
          }
        });
      },

      cleanAppointmentsFilter() {
        this.appointmentsFilter = {
          dateTime: { startDate: null, endDate: null },
          quantity: 10
        }
      },

      loadMoreAppointments() {
        this.appointmentsFilter.quantity += 10;
      },

      showFullHistory() {
        this.appointmentsFilter.quantity = 1000;

        this.$bvModal.show('history-modal');
      },

      findCep(value) {
        if (value != null && value.length == 9) {
          axios.get('https://viacep.com.br/ws/' + value + '/json/').then(res => {
            if (typeof res.data.erro == 'undefined') {
              let cepData = res.data;
              this.personForm.address.address = cepData.logradouro;
              this.personForm.address.neighborhood = cepData.bairro;
              this.personForm.address.city = cepData.localidade;
              this.personForm.address.state = cepData.uf;

              this.$refs.number.$el.focus();
            } else {
              this.$refs.address.$el.focus();
            }

            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Response CEP', res);
          }).catch(err => {
            this.$swal('Ops...', 'Não conseguimos localizar o seu CEP! Por favor, preencha os dados manualmente.', 'error');
            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Error CEP', err.response);
          });
        }
      },

      resetAttendanceGuideModal() {
        this.attendanceGuideForm = {
          id: null,
          appointment_id: null,
          health_plan_id: null,
          start_datetime: '',
          internal_id: '',
          name: '',
          professional: {
            name: '',
            commission_percentage: 0,
            specialities: [],
          },
          is_dentist: false,
          health_plan: '',
          bill_type: null,
          authorization_code: '',
          pending: true,
          items: [],
          invoices: [],
          item: {
            id: null,
            attendance_guide_invoice_id: null,
            tooth: null,
            faces: null,
            procedure: null,
            amount: 1,
            value: 0,
            accomplished: false
          }
        };
      },

      findAttendanceGuideProcedures(query) {
        this.attendanceGuideProcedures = [];
        if(query.length >= 3 && !this.isLoadingAttendanceGuideProcedures) {
          this.isLoadingAttendanceGuideProcedures = true;
          this.api.getProcedures({ term: query }).then(res => {
            if(this.leavingPage) {
              return;
            }
            this.isLoadingAttendanceGuideProcedures = false;

            this.attendanceGuideProcedures = res.data.data.map(procedure => {
              return { value: procedure.id, name: procedure.name, procedure_value: procedure.value, cnae: procedure.cnae };
            });
          }).catch(err => {
            if(this.leavingPage) {
              return;
            }
            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Error AttendanceGuideProcedures', err.response);
          });
        }
      },

      async addItemToAttendanceGuide() {
        if(!this.canPerformAction)
          return false;

        this.canPerformAction = false;

        const isValid = await this.$refs.attendanceGuideItemForm.validate();
        if(!isValid) {
          this.canPerformAction = true;
          return false;
        }

        let item = this.attendanceGuideForm.item;
        if(item.faces != null) {
          item.faces = item.faces.join(', ');
        }
        this.attendanceGuideForm.items.push(item);

        this.attendanceGuideForm.item = {
          tooth: null,
          faces: null,
          procedure: null,
          amount: 1,
          value: 0,
          accomplished: false
        };

        this.$refs.attendanceGuideItemForm.reset();
        this.canPerformAction = true;
      },

      async removeItemFromAttendanceGuide(index) {
        this.attendanceGuideForm.items.splice(index, 1);
      },

      async billAttendanceGuide() {
        if(!this.canPerformAction)
          return false;

        const isValid = await this.$refs.attendanceGuideForm.validate();
        if(!isValid) {
          return false;
        }
        if(this.attendanceGuideForm.items.length === 0) {
          this.$swal('Ops...', 'Você precisa adicionar ao menos um procedimento para salvar a guia de atendimento!', 'error');
          return false;
        }
        if(this.attendanceGuideForm.bill_type != null && this.attendanceGuideForm.bill_type.value === 'accomplished_procedures' && this.attendanceGuideForm.items.filter(item => item.accomplished && item.attendance_guide_invoice_id == null).length === 0) {
          this.$swal('Ops...', 'Só é possível faturar a guia de atendimento se ao menos um procedimento tiver sido realizado!', 'error');
          return false;
        }

        if(this.user.person.client.enable_mandic_nf) {
          let items = this.attendanceGuideForm.items,
              cnaes = [];
          if(this.attendanceGuideForm.bill_type != null && this.attendanceGuideForm.bill_type.value === 'accomplished_procedures') {
            items = items.filter(item => item.accomplished && item.attendance_guide_invoice_id == null);
          }
          items.forEach(item => {
            if(cnaes.indexOf(item.procedure.cnae) === -1) {
              cnaes.push(item.procedure.cnae);
            }
          });
          if(cnaes.length > 1) {
            this.$swal('Ops...', 'Procedimentos de CNAEs diferentes devem ser faturados separadamente.', 'error');
            return false;
          }
        }

        this.attendanceGuideForm.authorization_code = '';

        if(this.attendanceGuideForm.health_plan !== 'Particular') {
          let { value: authorizationCode } = await this.$swal({
            title: 'N° de Autorização de Guia de Atendimento',
            text: 'Informe o número de autorização para faturamento ' + (this.attendanceGuideForm.id == null ? 'desta guia' : ('da guia ' + this.attendanceGuideForm.internal_id)),
            input: 'text',
            inputLabel: 'Número de autorização',
            inputAttributes: {
              maxlength: 100,
            },
            showCancelButton: true,
            cancelButtonText: 'Cancelar',
            inputValidator: (value) => {
              if (!value) {
                return 'Você tem que preencher o número de autorização!'
              }
            }
          });
          if(authorizationCode) {
            this.attendanceGuideForm.authorization_code = authorizationCode;
            this.saveAttendanceGuide(true);
          }
        }
        else {
          this.saveAttendanceGuide(true);
        }
      },

      async saveAttendanceGuide(bill) {
        if(!this.canPerformAction)
          return false;

        this.canPerformAction = false;

        const isValid = await this.$refs.attendanceGuideForm.validate();
        if(!isValid) {
          this.canPerformAction = true;
          return false;
        }
        if(this.attendanceGuideForm.items.length === 0) {
          this.canPerformAction = true;
          this.$swal('Ops...', 'Você precisa adicionar ao menos um procedimento para salvar a guia de atendimento!', 'error');
          return false;
        }
        if(bill && this.attendanceGuideForm.bill_type != null && this.attendanceGuideForm.bill_type.value === 'accomplished_procedures' && this.attendanceGuideForm.items.filter(item => item.accomplished && item.attendance_guide_invoice_id == null).length === 0) {
          this.canPerformAction = true;
          this.$swal('Ops...', 'Só é possível faturar a guia de atendimento se ao menos um procedimento tiver sido realizado!', 'error');
          return false;
        }

        if(bill && this.user.person.client.enable_mandic_nf) {
          let items = this.attendanceGuideForm.items,
              cnaes = [];
          if(this.attendanceGuideForm.bill_type != null && this.attendanceGuideForm.bill_type.value === 'accomplished_procedures') {
            items = items.filter(item => item.accomplished && item.attendance_guide_invoice_id == null);
          }
          items.forEach(item => {
            if(cnaes.indexOf(item.procedure.cnae) === -1) {
              cnaes.push(item.procedure.cnae);
            }
          });
          if(cnaes.length > 1) {
            this.$swal('Ops...', 'Procedimentos de CNAEs diferentes devem ser faturados separadamente.', 'error');
            return false;
          }
        }

        let attendanceGuideData = {
          bill_type: this.attendanceGuideForm.bill_type != null ? this.attendanceGuideForm.bill_type.value : null,
          bill: bill,
          authorization_code: bill ? this.attendanceGuideForm.authorization_code : null,
          items: this.attendanceGuideForm.items.map(item => {
            return {
              id: item.id,
              procedure_id: item.procedure.value,
              tooth: item.tooth,
              faces: item.faces,
              amount: item.amount,
              value: item.value,
              accomplished: item.accomplished
            }
          })
        };

        this.eventBus.$emit('IS_LOADING', true);
        if(this.attendanceGuideForm.id == null) {
          attendanceGuideData.health_plan_id = this.attendanceGuideForm.health_plan_id;

          await this.api.storeAttendanceGuide(this.attendanceGuideForm.appointment_id, attendanceGuideData).then(res => {
            this.eventBus.$emit('IS_LOADING', false);
            this.canPerformAction = true;

            if (res.status == 201) {
              this.$bvModal.hide('attendance-guide-modal');
              if(bill) {
                let transactionId = res.data.id;
                this.$swal('Uhull \\o/', 'A guia de atendimento foi cadastrada com sucesso! Agora finalize o cadastro da fatura.', 'success').then(() => {
                  this.$router.push({path: '/financeiro/contas-a-receber/' + transactionId}).catch(() => {});
                });
              }
              else {
                this.getPatientExtraData();
                this.$swal('Uhull \\o/', 'A guia de atendimento foi cadastrada com sucesso!', 'success');
              }
            } else {
              this.$swal('Ops...', 'Ocorreu um erro ao cadastrar esta guia de atendimento! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
            }

            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Response Store Attendance Guide', res);
          }).catch(err => {
            this.eventBus.$emit('IS_LOADING', false);
            this.canPerformAction = true;

            let msg = 'Não conseguimos cadastrar esta guia de atendimento! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';

            switch (err.response.status) {
              case 422: msg = err.response.data.errors.join('\r\n'); break;
            }

            this.$swal('Ops...', msg, 'error');
            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Error Store Attendance Guide', err.response);
          });
        }
        else {
          await this.api.updateAttendanceGuide(this.attendanceGuideForm.appointment_id, this.attendanceGuideForm.id, attendanceGuideData).then(res => {
            this.eventBus.$emit('IS_LOADING', false);
            this.canPerformAction = true;

            if (res.status == 201) {
              this.$bvModal.hide('attendance-guide-modal');
              if(bill) {
                let transactionId = res.data.id;
                this.$swal('Uhull \\o/', 'A guia de atendimento foi atualizada com sucesso! Agora finalize o cadastro da fatura.', 'success').then(() => {
                  this.$router.push({path: '/financeiro/contas-a-receber/' + transactionId}).catch(() => {});
                });
              }
              else {
                this.getPatientExtraData();
                this.$swal('Uhull \\o/', 'A guia de atendimento foi atualizada com sucesso!', 'success');
              }
            } else {
              this.$swal('Ops...', 'Ocorreu um erro ao atualizar esta guia de atendimento! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
            }

            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Response Update Attendance Guide', res);
          }).catch(err => {
            this.eventBus.$emit('IS_LOADING', false);
            this.canPerformAction = true;

            try {
              this.eventBus.$emit('IS_LOADING', false);
              this.canPerformAction = true;

              let msg = 'Não conseguimos atualizar esta guia de atendimento! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';

              switch (err.response.status) {
                case 422: msg = err.response.data.errors.join('\r\n'); break;
              }

              this.$swal('Ops...', msg, 'error');
            } catch(err2) {
              this.$swal('Erro', 'Por favor tire um print / foto e envie para nosso suporte:\n\nMethod: catchUpdateAttendanceGuide\nError:'+err.toString(), 'warning');
              this.sentry.captureException(err);
            }
            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
              console.log('Error Update Attendance Guide', err.response);
          });
        }
      },

      showAttendanceGuideModal(attendanceGuide) {
        if(!this.canPerformAction)
          return false;

        if(attendanceGuide != null) {
          this.attendanceGuideForm.id = attendanceGuide.id;
          this.attendanceGuideForm.appointment_id = attendanceGuide.appointment_id;
          this.attendanceGuideForm.start_datetime = this.moment(attendanceGuide.appointment.start_datetime).format('DD/MM/YYYY HH:mm');
          this.attendanceGuideForm.internal_id = attendanceGuide.internal_id;
          this.attendanceGuideForm.name = attendanceGuide.patient.name;
          this.attendanceGuideForm.professional = attendanceGuide.appointment.professional;
          this.attendanceGuideForm.professional.commission_percentage = this.attendanceGuideForm.professional.commission_percentage != null ? this.attendanceGuideForm.professional.commission_percentage : 0;
          this.attendanceGuideForm.health_plan = attendanceGuide.appointment.health_plan.name;
          this.attendanceGuideForm.bill_type = this.billTypeOptions.find(billType => billType.value == attendanceGuide.bill_type);
          this.attendanceGuideForm.pending = attendanceGuide.pending;
          this.attendanceGuideForm.items = attendanceGuide.items;
          this.attendanceGuideForm.invoices = attendanceGuide.attendance_guide_invoices;
          this.attendanceGuideForm.invoices.forEach(invoice => {
            invoice.transactions = invoice.transactions.sort((a, b) => (a.charge_date > b.charge_date)?1:-1);
          });
          let dentistSpecialty = attendanceGuide.appointment.professional.specialities.find(specialty => {
            return specialty.group === 'Odontologia';
          });
          this.attendanceGuideForm.is_dentist = dentistSpecialty !== undefined;
        }
        else {
          this.attendanceGuideForm.id = null;
          this.attendanceGuideForm.appointment_id = this.attendanceGuideAppointment.id;
          this.attendanceGuideForm.start_datetime = this.moment(this.attendanceGuideAppointment.start_datetime).format('DD/MM/YYYY HH:mm');
          this.attendanceGuideForm.internal_id = '';
          this.attendanceGuideForm.name = this.attendanceGuideAppointment.patient.name;
          this.attendanceGuideForm.professional = this.attendanceGuideAppointment.professional;
          this.attendanceGuideForm.professional.commission_percentage = this.attendanceGuideForm.professional.commission_percentage != null ? this.attendanceGuideForm.professional.commission_percentage : 0;
          this.attendanceGuideForm.health_plan = this.attendanceGuideAppointment.health_plan.name;
          this.attendanceGuideForm.health_plan_id = this.attendanceGuideAppointment.health_plan.id;
          this.attendanceGuideForm.bill_type = this.helpers.planHasPermission('financial') ? null : this.billTypeOptions.find(g => g.value == 'full_guide');
          this.attendanceGuideForm.pending = true;
          this.attendanceGuideForm.items = [];
          this.attendanceGuideForm.invoices = [];
          let dentistSpecialty = this.attendanceGuideAppointment.professional.specialities.find(specialty => {
            return specialty.group === 'Odontologia';
          });
          this.attendanceGuideForm.is_dentist = dentistSpecialty !== undefined;
        }

        // this.attendanceGuideForm
        this.$bvModal.show('attendance-guide-modal');
        this.canPerformAction = true;
      },

      isNullOrEmpty(value) {
        return value == null || value == '';
      },

      async addNewPrescriptionToAttendance() {
        if(!this.canPerformAction || this.attendanceInProgress == null || this.user.person.professional_registration == null)
          return false;

        let personAddress = this.personForm.address;
        if(this.isNullOrEmpty(this.personForm.document) || this.isNullOrEmpty(this.personForm.cellphone) || this.isNullOrEmpty(this.personForm.gender.value) || personAddress == null
            || this.isNullOrEmpty(personAddress.zip_code) || this.isNullOrEmpty(personAddress.address) || this.isNullOrEmpty(personAddress.number) || this.isNullOrEmpty(personAddress.city)
            || this.isNullOrEmpty(personAddress.state)) {
          let missingFields = [];
          if(this.isNullOrEmpty(this.personForm.document)) {
            missingFields.push('CPF');
          }
          if(this.isNullOrEmpty(this.personForm.cellphone)) {
            missingFields.push('celular');
          }
          if(this.isNullOrEmpty(this.personForm.gender.value)) {
            missingFields.push('sexo');
          }
          if(personAddress == null || this.isNullOrEmpty(personAddress.zip_code) || this.isNullOrEmpty(personAddress.address) || this.isNullOrEmpty(personAddress.number) || this.isNullOrEmpty(personAddress.city) || this.isNullOrEmpty(personAddress.state)) {
            missingFields.push('endereço completo');
          }
          missingFields = missingFields.join(', ').replace(/,(?=[^,]*$)/, ' e');

          this.$swal({
            title: 'Você precisa preencher o ' + missingFields + ' do paciente para criar um receituário digital!',
            type: 'warning',
            showCancelButton: true,
            confirmButtonText: 'OK',
            cancelButtonText: 'Cancelar',
            focusCancel: true
          }).then((res) => {
            if(res.value) {
              this.preview = false;
            }
          });
          return false;
        }

        this.canPerformAction = false;
        this.eventBus.$emit('IS_LOADING', true);

        this.api.initPrescription(this.personForm.id).then(res => {
          this.eventBus.$emit('IS_LOADING', false);
          this.canPerformAction = true;

          this.currentPrescription = {
            'id': res.data.id,
            'embed_url': res.data.embed_url,
            'external_id': res.data.prescription.idPrescricao
          };
          this.$bvModal.show('prescription-form-modal');

          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Response Start Prescription', res);
        }).catch(err => {
          this.eventBus.$emit('IS_LOADING', false);
          this.canPerformAction = true;

          let msg = 'Não conseguimos inicializar o receituário digital. Por favor, entre em contato com o suporte!';

          if (typeof err.response != 'undefined')
            switch (err.response.status) {
              case 400:
                msg = err.response.data.message;
                break;
              case 422:
                msg = err.response.data.errors.join('\r\n');
                break;
            }

          this.$swal('Ops...', msg, 'error');
          if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
            console.log('Error Start Prescription', err.response);
        });
      },

      processPrescriptionEvent(event) {
        const validEvents = ['cancel', 'excluded', 'prescricao'];
        if(validEvents.includes(event.data.type)) {
          this.$bvModal.hide('prescription-form-modal');
          if(event.data.type == 'prescricao' && this.currentPrescription != null) {
            this.currentPrescription.value = event.data;
            this.attendancePrescriptions.push(this.currentPrescription);
            this.currentPrescription = null;
          }
        }
      },
      buildFormSelectedAddress(unit) {
        let address = unit.display_address;
        if(address != null) {
          return address.address+', '+address.number+' - '+address.city+', '+address.state;
        }
      },

      goBack() {
        if(this.personForm.type == 'PATIENT')
          this.$router.go();
        else
          this.$router.push({path: '/' + this.url}).catch(() => {});
      }
    },

    beforeDestroy() {
      if(this.interval != null) {
        clearInterval(this.interval);
        // localStorage.setItem('attendanceForms_' + this.$route.params.id, compressToUTF16(JSON.stringify(this.attendanceForms)));
        try {
          localStorage.setItem('attendanceForms_' + this.$route.params.id, JSON.stringify(this.attendanceForms));
        } catch (err) {
          this.sentry.captureMessage(JSON.stringify(this.attendanceForms));
          throw err;
        }
        localStorage.setItem('attendancePrescriptions_' + this.$route.params.id, JSON.stringify(this.attendancePrescriptions));
      }
      if(this.user != null && this.user.person.type == 'PROFESSIONAL') {
        window.removeEventListener('message', this.processPrescriptionEvent);
      }
    },

    beforeRouteLeave (to, from, next) {
      this.leavingPage = true;
      next();
    }
  }
</script>

<style lang="scss">
  .person-form {
    padding: 20px 0;

    .table.table-responsive tbody td {
      font-size: 15px;
    }

    .today-appointments .appointments-list li:last-child {
      padding-bottom: 0;
    }

    .appointments-list {
      padding-left: 9px;

      li {
        padding: 2px 20px 15px 20px;
        position: relative;
        transition: all 0.5s;

        &:after {
          width: 8px;
          height: 8px;
          border-radius: 50%;
          background-color: #FFFFFF;
          border: 2px solid $linkWater;
          content: ' ';
          position: absolute;
          top: 10px;
          left: -4px;
          transition: all 0.5s;
        }

        .timeline {
          position: absolute;
          width: 2px;
          height: 100%;
          background-color: $linkWater;
          left: -1px;
          top: 10px;
        }

        &.current-day {
          &:after {
            border-color: $pictionBlue;
          }

          &:before {
            width: 14px;
            height: 14px;
            border-radius: 50%;
            background-color: $columbiaBlue;
            content: ' ';
            position: absolute;
            top: 7px;
            left: -7px;
            transition: all 0.5s;
          }
        }

        &:last-child {
          .timeline {
            display: none;
          }
        }
      }

      p {
        font-family: 'sf_pro_displaymedium';
        margin: 0;
      }

      .audit-btn {
        color: $pictionBlue;
        cursor: pointer;
      }

      .attendance-item {
        color: $pictionBlue;
        width: 100%;
        cursor: pointer;
        font-size: 15px;
      }

      .reminder-item {
        color: $pictionBlue;
        width: 100%;
        cursor: pointer;
        font-size: 14px;
      }

      .info {
        font-weight: 500;
        color: $waikawaGray;

        .row {
          padding-bottom: 5px;
          margin-bottom: 10px;
          border-bottom: 1px solid $linkWater;
        }
      }

      .date {
        color: $cadetGray;
        font-size: 15px;
      }
    }

    .time {
      font-size: 36px;
      line-height: 36px;
      color: $linkWater;
      font-family: 'sf_pro_displaymedium';
    }

    .preview {
      color: $waikawaGray;
      font-size: 14px;

      &.name {
        font-size: 18px;
        color: $bunting;
      }
    }

    .show-full {
      font-size: 12px;
      color: $cadetGray;
      cursor: pointer;
    }

    .printable {
      display: none;
    }

    .photo-container {
      position: relative;
      text-align: center;

      .person-photo {
        cursor: pointer;
        margin-left: 15px;
        margin-right: 15px;
        width: 70px;
        height: 70px;
        background: #f0f0f0 no-repeat 50%;
        background-size: contain;
        border: 1px solid $linkWater;

        &#personPhotoPreview {
          cursor: default;
        }
      }

      .delete-photo {
        position: absolute;
        top: 0;
        right: 15px;
        padding: 0.25rem 0.45rem;
        font-size: 0.8rem;
      }
    }

    @media print {
      & > .container, .box-fullcalendar {
        display: none !important;
      }

      .printable {
        display: block !important;
        padding: 20px;

        .print-header {
          padding: 0 18px 15px;
          width: 100%;

          img {
            position: relative;
            display: inline-block;
            vertical-align: baseline;
            margin-right: 24px;
          }
          .print-client-info {
            width: calc(50% - 62px);
            position: relative;
            display: inline-block;
            font-size: 14px;

            h1 {
              font-size: 20px;
            }
          }
        }

        .fields {
          position: relative;

          .field {
            position: relative;
            display: inline-block;
            margin: 10px 15px;
            border: 1px solid #000000;
            border-radius: 0;
            background-color: #ffffff;
            padding: 15px 15px;
            page-break-after: auto;
            page-break-inside: avoid;

            &.field-3 { width: calc(25% - 30px); }
            &.field-4 { width: calc(33% - 30px); }
            &.field-6 { width: calc(50% - 30px); }
            &.field-9 { width: calc(75% - 30px); }
            &.field-12 { width: calc(100% - 30px); }

            label {
              position: absolute;
              top: -12px;
              left: 15px;
              background-color: #ffffff;
              padding: 3px 5px;
              color: #000000;
            }

            textarea {
              resize: none;
            }

            .form-control {
              border: none;
              background-color: transparent;
              padding: 0;
            }
          }
        }
      }
    }
  }

  .header {
    &.appointment-history-header {
      padding: 15px 20px 0 12px!important;

      .nav-tabs {
        margin-bottom: -1px;
        border-bottom: 1px solid $athenGray2;

        .show-appointments {
          font-size: 15px;
          color: $cadetGray;
          padding: 0.5rem 0.7rem;

          &.active {
            border-color: $athenGray2 $athenGray2 #fff;
            color: $bunting;
          }
          &:hover {
            border-color: #e9ecef #e9ecef $athenGray2;
            color: $bunting;
          }
        }
      }
    }
  }

  .notes-container {
    border-left: 1px solid $cadetGray;

    .note-value {
      color: $waikawaGray;
      font-size: 14px;
    }

    @media only screen and (max-width : 767px) {
      border-left: 0;
      border-top: 1px solid $cadetGray;
      padding-top: 10px;
      margin-top: 10px;
    }
  }

  #prescription-form-modal {
    .modal-dialog {
      margin: 15px auto;

      .modal-body {
        padding: 0;

        iframe {
          width: 100%;
          height: calc(100vh - 40px);
        }
      }
    }

    @media only screen and (max-width : 576px) {
      padding-left: 5px!important;
      padding-right: 5px!important;

      &___BV_modal_outer_ {
        z-index: 1000000000!important;
      }

      .modal-dialog {
        margin: 10px auto;

        .modal-body iframe {
          height: calc(100vh - 30px);
        }
      }
    }
  }

  .text1 {
    font-size: 15px;
    color: $cadetGray;
    margin-bottom: 0;
  }

  #audit-modal tbody td {
    font-size: 13px;
    padding: .5rem .7rem;
  }
</style>
